(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5603],{

/***/ 15603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Lr": function() { return /* reexport */ DatePickerComponent; },
  "ML": function() { return /* reexport */ Editor; },
  "OL": function() { return /* reexport */ UniEditor; },
  "sk": function() { return /* reexport */ UniEditorSmall; }
});

// UNUSED EXPORTS: DateRangeComponent, ImageInput, MultipleFileInput, TimePeriod, UniEditorDefault, UniEditorMedium, UniSugessions

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/suneditor/dist/css/suneditor.min.css
var suneditor_min = __webpack_require__(32462);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./_unisearch/common/form/editor.jsx
 //https://github.com/mkhstar/suneditor-react




var SunEditor = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(5714), __webpack_require__.e(1876), __webpack_require__.e(3829)]).then(__webpack_require__.t.bind(__webpack_require__, 21288, 23));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(21288)];
    }
  }
});
var Editor = function Editor(_ref) {
  var name = _ref.name,
      contents = _ref.contents,
      onChange = _ref.onChange,
      height = _ref.height,
      is_small = _ref.is_small;
  var options = {
    mode: "classic",
    rtl: false,
    katex: "window.katex",
    imageGalleryUrl: "https://api.myunisearch.com/file-manager/all",
    videoFileInput: false,
    tabDisable: false,
    height: height || 400,
    buttonList: is_small ? [["undo", "redo", "font", "fontSize", "formatBlock", "blockquote", "bold", "underline", "italic", "align", "fontColor", "list", "lineHeight"]] : [["undo", "redo", "font", "fontSize", "formatBlock", "paragraphStyle", "blockquote", "bold", "underline", "italic", "strike", "subscript", "superscript", "fontColor", "hiliteColor", "textStyle", "removeFormat", "outdent", "indent", "align", "horizontalRule", "list", "lineHeight", "table", "link", // "image",
    // "video",
    // "audio",
    // "math",
    "imageGallery", "fullScreen", "showBlocks", "codeView", "preview" // "print",
    // "save",
    // "template",
    ]],
    "lang(In nodejs)": "en"
  };
  var target_name = name || "description";

  var _useState = (0,react.useState)(),
      editorState = _useState[0],
      setEditorState = _useState[1];

  (0,react.useEffect)(function () {
    setEditorState(contents || "");
  }, [contents]);

  var handleChange = function handleChange(content) {
    setEditorState(content);

    if (onChange) {
      var target = {
        name: target_name,
        value: content
      };
      onChange({
        target: target
      });
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(SunEditor, {
      setOptions: options,
      onChange: handleChange,
      setContents: editorState
    })
  });
};
/* harmony default export */ var editor = ((/* unused pure expression or super */ null && (Editor)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
// EXTERNAL MODULE: ./_unisearch/common/media/index.js + 4 modules
var media = __webpack_require__(12083);
// EXTERNAL MODULE: ./_unisearch/common/ui_element/pagination/index.jsx
var pagination = __webpack_require__(59076);
// EXTERNAL MODULE: ./_unisearch/helpers/index.js + 6 modules
var helpers = __webpack_require__(72145);
// EXTERNAL MODULE: ./_unisearch/helpers/api/index.js
var api = __webpack_require__(85014);
// EXTERNAL MODULE: ./node_modules/react-svg/dist/react-svg.esm.js + 1 modules
var react_svg_esm = __webpack_require__(98547);
// EXTERNAL MODULE: ./node_modules/react-loading-skeleton/dist/skeleton.css
var skeleton = __webpack_require__(36860);
;// CONCATENATED MODULE: ./_unisearch/common/loader/media_screen.js






var media_screen_MediaScreen = function MediaScreen() {
  return /*#__PURE__*/_jsxs("div", {
    className: styles.boxItem,
    children: [/*#__PURE__*/_jsx(Skeleton, {
      width: "100%",
      height: "120px"
    }), /*#__PURE__*/_jsx(Skeleton, {
      width: "100%",
      height: "25px"
    }), /*#__PURE__*/_jsx(Skeleton, {
      width: "100%",
      height: "20px"
    }), /*#__PURE__*/_jsx(Skeleton, {
      width: "39px",
      height: "20px"
    })]
  });
};
/* harmony default export */ var media_screen = ((/* unused pure expression or super */ null && (media_screen_MediaScreen)));
;// CONCATENATED MODULE: ./_unisearch/common/media/MediaBox.js
/* eslint-disable @next/next/no-img-element */

/* eslint-disable eqeqeq */







var MediaBox_MediaBox = function MediaBox(props) {
  var _props$data = props.data,
      src = _props$data.src,
      mimetype = _props$data.mimetype,
      mediaName = _props$data.mediaName;

  var handleClick = function handleClick() {
    if (props.onClick) props.onClick(props.data);
  };

  var PreviewItem = function PreviewItem(src) {
    var extension = src.split(".").pop();
    var imagePath = src || getAssets("assets/images/vector-image.png");

    if (extension == "pdf" || mimetype == "application/pdf") {
      return /*#__PURE__*/_jsxs("div", {
        className: styles.filterArea,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.checkIcon,
          children: props.is_selected ? /*#__PURE__*/_jsx(RiCheckboxFill, {}) : /*#__PURE__*/_jsx(RiCheckboxBlankLine, {})
        }), /*#__PURE__*/_jsx("div", {
          className: styles.icon_wrapper,
          children: /*#__PURE__*/_jsx(ReactSVG, {
            className: styles.icon,
            src: getAssets("assets/icons/pdf_icon.svg")
          })
        }), /*#__PURE__*/_jsx("div", {
          className: styles.name,
          children: /*#__PURE__*/_jsxs("h4", {
            children: [mediaName || "", " "]
          })
        })]
      });
    }

    if (extension == "xls" || extension == "xlsx" || mimetype == "application/xlsx") {
      return /*#__PURE__*/_jsxs("div", {
        className: styles.filterArea,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.checkIcon,
          children: props.is_selected ? /*#__PURE__*/_jsx(RiCheckboxFill, {}) : /*#__PURE__*/_jsx(RiCheckboxBlankLine, {})
        }), /*#__PURE__*/_jsx("div", {
          className: styles.icon_wrapper,
          children: /*#__PURE__*/_jsx(ReactSVG, {
            className: styles.icon,
            src: getAssets("assets/icons/xls_icon.svg")
          })
        }), /*#__PURE__*/_jsx("div", {
          className: styles.name,
          children: /*#__PURE__*/_jsxs("h4", {
            children: [mediaName || "", " "]
          })
        })]
      });
    }

    if (extension == "docx" || extension == "doc" || mimetype == "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || mimetype == "application/doc") {
      return /*#__PURE__*/_jsxs("div", {
        className: styles.filterArea,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.checkIcon,
          children: props.is_selected ? /*#__PURE__*/_jsx(RiCheckboxFill, {}) : /*#__PURE__*/_jsx(RiCheckboxBlankLine, {})
        }), /*#__PURE__*/_jsx("div", {
          className: styles.icon_wrapper,
          children: /*#__PURE__*/_jsx(ReactSVG, {
            className: styles.icon,
            src: getAssets("assets/icons/doc_icon.svg")
          })
        }), /*#__PURE__*/_jsx("div", {
          className: styles.name,
          children: /*#__PURE__*/_jsxs("h4", {
            children: [mediaName || "", " "]
          })
        })]
      });
    }

    if (extension == "jpg" || extension == "png" || extension == "svg" || extension == "webp" || mimetype == "image/jpeg" || mimetype == "image/svg+xml" || mimetype == "image/png") {
      return /*#__PURE__*/_jsxs("div", {
        className: styles.imageArea,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.checkIcon,
          children: props.is_selected ? /*#__PURE__*/_jsx(RiCheckboxFill, {}) : /*#__PURE__*/_jsx(RiCheckboxBlankLine, {})
        }), /*#__PURE__*/_jsx("div", {
          className: styles.mediaContent,
          children: /*#__PURE__*/_jsx("img", {
            src: imagePath,
            alt: ""
          })
        }), /*#__PURE__*/_jsx("div", {
          className: styles.name,
          children: /*#__PURE__*/_jsxs("h4", {
            children: [mediaName || "", " "]
          })
        })]
      });
    }

    if (extension == "mp4" || mimetype == "video/mp4") {
      return /*#__PURE__*/_jsxs("div", {
        className: styles.filterArea,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.icon_wrapper,
          children: /*#__PURE__*/_jsx(ReactSVG, {
            className: styles.icon,
            src: getAssets("assets/icons/video_icon.svg")
          })
        }), /*#__PURE__*/_jsx("div", {
          className: styles.name,
          children: /*#__PURE__*/_jsxs("h4", {
            children: [mediaName || "", " "]
          })
        })]
      });
    } // <div className={styles.filterArea}>
    //   <video width="100%" height="130" controls="controls" preload="none">
    //     <source src={imagePath} type="video/mp4" autostart="false" />
    //     Your browser does not support the video tag.
    //   </video>
    //   <span className={styles.name}> {mediaName || ""} </span>
    // </div>;


    return /*#__PURE__*/_jsxs("div", {
      className: styles.imageArea,
      children: [/*#__PURE__*/_jsx("div", {
        className: styles.checkIcon,
        children: props.is_selected ? /*#__PURE__*/_jsx(RiCheckboxFill, {}) : /*#__PURE__*/_jsx(RiCheckboxBlankLine, {})
      }), /*#__PURE__*/_jsx("div", {
        className: styles.mediaContent,
        children: /*#__PURE__*/_jsx("img", {
          src: imagePath,
          alt: ""
        })
      }), /*#__PURE__*/_jsx("div", {
        className: styles.name,
        children: /*#__PURE__*/_jsxs("h4", {
          children: [mediaName || "", " "]
        })
      })]
    });
  };

  return /*#__PURE__*/_jsx("div", {
    className: "".concat(props.is_selected ? styles.selected : styles.button),
    onClick: function onClick() {
      return handleClick();
    },
    style: {
      height: "100%"
    },
    children: PreviewItem(src)
  });
};
/* harmony default export */ var media_MediaBox = ((/* unused pure expression or super */ null && (MediaBox_MediaBox)));
;// CONCATENATED MODULE: ./_unisearch/common/form/ImageInput.js





function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable @next/next/no-img-element */

/* eslint-disable react-hooks/exhaustive-deps */



















var style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4
};
var ImageInput = function ImageInput(_ref) {
  var name = _ref.name,
      url = _ref.url,
      onChange = _ref.onChange,
      returnItem = _ref.returnItem,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? false : _ref$value,
      _ref$component_type = _ref.component_type,
      component_type = _ref$component_type === void 0 ? "default" : _ref$component_type,
      guideLine = _ref.guideLine,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? "Upload Image" : _ref$title,
      _ref$allowItem = _ref.allowItem,
      allowItem = _ref$allowItem === void 0 ? "image" : _ref$allowItem;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1]; //handle open


  var handleOpen = function handleOpen(data) {
    setOpen(data);
  }; //handle close


  var handleClose = function handleClose(e) {
    e.preventDefault();
    setOpen(false);
  }; //initial media name and files


  var target_name = name || "featured_image";
  var FILES_URL = "/media-manager/find-mediaFile";

  var _useState = useState(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useState2 = useState(false),
      is_EnableForm = _useState2[0],
      setEnableForm = _useState2[1]; //get Media Data


  var _useState3 = useState([]),
      mediaData = _useState3[0],
      setMediaData = _useState3[1];

  var _useState4 = useState({}),
      paginate = _useState4[0],
      setPaginate = _useState4[1]; //search search state


  var _useState5 = useState({
    filter: {
      mediaName: "",
      alt: "",
      tag: allowItem
    },
    sortOrder: "DESC",
    sortField: "mediaManagerId",
    pageNumber: 1,
    pageSize: 10
  }),
      searchFields = _useState5[0],
      setSearchFields = _useState5[1];

  var paginationHandler = function paginationHandler(event, page) {
    setSearchFields(_objectSpread(_objectSpread({}, searchFields), {}, {
      pageNumber: page
    }));
  }; //handle serach input


  var handleInput = function handleInput(e) {
    var _e$target = e.target,
        name = _e$target.name,
        value = _e$target.value;

    var filter = _objectSpread(_objectSpread({}, searchFields.filter), {}, _defineProperty({}, name, value));

    setSearchFields(_objectSpread(_objectSpread({}, searchFields), {}, {
      filter: filter,
      pageNumber: 1
    }));
  };

  var handleOrder = function handleOrder(e) {
    var _objectSpread3;

    var _e$target2 = e.target,
        name = _e$target2.name,
        value = _e$target2.value;
    setSearchFields(_objectSpread(_objectSpread({}, searchFields), {}, (_objectSpread3 = {}, _defineProperty(_objectSpread3, name, value), _defineProperty(_objectSpread3, "pageNumber", 1), _objectSpread3)));
  }; //when click on handle serach button


  var handleSearch = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              //loading true
              setLoading(true); //post handle search

              _context.next = 3;
              return API.post("".concat(FILES_URL), searchFields).then(function (response) {
                if (response.error) {
                  swalError("Something Wrong!");
                }

                if (!response.error) {
                  var _response$data = response.data,
                      total = _response$data.total,
                      results = _response$data.results,
                      currentPage = _response$data.currentPage,
                      page_total = _response$data.page_total,
                      limit = _response$data.limit; //set Paginate Info

                  setPaginate({
                    total: total,
                    currentPage: currentPage,
                    page_total: page_total,
                    limit: limit
                  }); //set media data

                  setMediaData(results);
                }
              })["catch"](function (error) {
                swalError(error);
              });

            case 3:
              //loading false
              setLoading(false);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSearch() {
      return _ref2.apply(this, arguments);
    };
  }(); //Manage image path


  var placeholder = allowItem && allowItem == "video" ? "/assets/images/vector-image.png" : "/assets/images/vector-image.png";

  var _useState6 = useState(placeholder),
      imageUrl = _useState6[0],
      setImageUrl = _useState6[1];

  var _useState7 = useState(),
      selected = _useState7[0],
      setSelected = _useState7[1];

  var imageChange = function imageChange(data) {
    if (selected && selected.mediaManagerId == data.mediaManagerId) {
      setSelected("");
    } else {
      setSelected(data);
    }
  };

  var handleInsert = function handleInsert() {
    setImageUrl(selected.src); //pass parent props

    if (onChange) {
      var target = {
        name: target_name,
        value: selected[returnItem]
      };
      onChange({
        target: target
      });
    }

    setOpen(false);
  };

  var PreviewImage = function PreviewImage(imageUrl) {
    var extension = imageUrl.split(".").pop();

    if (extension == "pdf") {
      return /*#__PURE__*/_jsx(ReactSVG, {
        className: styles.icon,
        src: getAssets("assets/icons/pdf_icon.svg")
      });
    }

    if (extension == "xlsx" || extension == "xls") {
      return /*#__PURE__*/_jsx(ReactSVG, {
        className: styles.icon,
        src: getAssets("assets/icons/xls_icon.svg")
      });
    }

    if (extension == "docx" || extension == "doc") {
      return /*#__PURE__*/_jsx(ReactSVG, {
        className: styles.icon,
        src: getAssets("assets/icons/doc_icon.svg")
      });
    }

    if (extension == "mp4") {
      return /*#__PURE__*/_jsxs("video", {
        width: "100%",
        height: "180",
        controls: "controls",
        preload: "none",
        children: [/*#__PURE__*/_jsx("source", {
          src: imageUrl,
          type: "video/mp4",
          autostart: "false"
        }), "Your browser does not support the video tag."]
      });
    }

    if (extension == "jpg" || extension == "jpeg" || extension == "png" || extension == "webp" || extension == "svg") {
      return /*#__PURE__*/_jsxs("div", {
        className: styles.media_image_wrapper,
        children: [/*#__PURE__*/_jsx("img", {
          src: imageUrl,
          alt: ""
        }), imageUrl === "/assets/images/vector-image.png" ? /*#__PURE__*/_jsx(HiPlusCircle, {
          className: "admin_upload_image_icon"
        }) : null]
      });
    }

    return /*#__PURE__*/_jsx("img", {
      src: imageUrl,
      alt: ""
    });
  }; //when change page


  useEffect(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!open) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return handleSearch();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function fetchData() {
        return _ref3.apply(this, arguments);
      };
    }();

    fetchData();
  }, [searchFields.pageNumber, searchFields.sortOrder]);
  useEffect(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(open && mediaData.length <= 0)) {
                  _context3.next = 3;
                  break;
                }

                _context3.next = 3;
                return handleSearch();

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function fetchData() {
        return _ref4.apply(this, arguments);
      };
    }();

    fetchData();
  }, [open]); //change image url

  useEffect(function () {
    if (url) {
      setImageUrl(url);
    } else {
      setImageUrl(placeholder);
    }
  }, [url, placeholder]); //handleList

  var handleList = function handleList() {
    setEnableForm(false);
  }; //get data form child


  var handleUploaded = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(result) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!result) {
                _context4.next = 6;
                break;
              }

              setEnableForm(false);
              _context4.next = 4;
              return handleSearch();

            case 4:
              _context4.next = 7;
              break;

            case 6:
              swalError("Upload Error");

            case 7:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleUploaded(_x) {
      return _ref5.apply(this, arguments);
    };
  }(); //remove this item


  var handleRemove = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (selected && selected.mediaManagerId) {
                swalConfirm("you want to remove this item?", "Are you sure", "Yes Remove").then( /*#__PURE__*/function () {
                  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(res) {
                    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            if (!res.isConfirmed) {
                              _context6.next = 3;
                              break;
                            }

                            _context6.next = 3;
                            return API["delete"]("media-manager/delete/".concat(parseInt(selected.mediaManagerId))).then( /*#__PURE__*/function () {
                              var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(res) {
                                var pageNumber;
                                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                                  while (1) {
                                    switch (_context5.prev = _context5.next) {
                                      case 0:
                                        pageNumber = paginate.page_total >= 2 ? paginate.currentPage : paginate.currentPage > 1 && paginate.page_total == 1 ? parseInt(paginate.currentPage - 1) : paginate.currentPage; //clear selected state

                                        setSelected(""); //search again

                                        setSearchFields(_objectSpread(_objectSpread({}, searchFields), {}, {
                                          pageNumber: pageNumber
                                        }));

                                        if (!(pageNumber == paginate.currentPage)) {
                                          _context5.next = 6;
                                          break;
                                        }

                                        _context5.next = 6;
                                        return handleSearch();

                                      case 6:
                                      case "end":
                                        return _context5.stop();
                                    }
                                  }
                                }, _callee5);
                              }));

                              return function (_x3) {
                                return _ref8.apply(this, arguments);
                              };
                            }());

                          case 3:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6);
                  }));

                  return function (_x2) {
                    return _ref7.apply(this, arguments);
                  };
                }());
              } else {
                swalError("Please select any one media item");
              }

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function handleRemove() {
      return _ref6.apply(this, arguments);
    };
  }(); //remove selected items from state


  var handleClear = function handleClear() {
    swalConfirm("Remove this item", "Are you sure", "Yes Delete").then(function (rsp) {
      if (rsp.isConfirmed) {
        setImageUrl(placeholder);
        setSelected("");

        if (onChange) {
          var target = {
            name: "",
            value: ""
          };
          onChange({
            target: target
          });
        }
      }
    });
  };

  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(Grid, {
      container: true,
      spacing: 4,
      children: /*#__PURE__*/_jsx(Grid, {
        item: true,
        md: 12,
        sm: 12,
        children: /*#__PURE__*/_jsxs("div", {
          className: styles.form_group,
          children: [/*#__PURE__*/_jsx("label", {
            children: title
          }), /*#__PURE__*/_jsxs("div", {
            className: styles.media_form_group,
            children: [/*#__PURE__*/_jsxs("div", {
              className: styles.button_area,
              children: [/*#__PURE__*/_jsx("button", {
                className: styles.upload_btn,
                onClick: function onClick(e) {
                  return handleOpen(true);
                },
                type: "button",
                children: PreviewImage(imageUrl)
              }), value && value != undefined && value != 0 && /*#__PURE__*/_jsxs("button", {
                type: "button",
                className: styles.clearOld,
                onClick: function onClick() {
                  return handleClear();
                },
                children: [/*#__PURE__*/_jsx(FaTrash, {}), " ", /*#__PURE__*/_jsx("span", {
                  className: "hide-sm"
                })]
              })]
            }), /*#__PURE__*/_jsxs("div", {
              children: [allowItem && allowItem == "image" && /*#__PURE__*/_jsxs(Fragment, {
                children: [guideLine && /*#__PURE__*/_jsxs("div", {
                  className: styles.text1,
                  children: ["Important Guidelines: ", guideLine]
                }), allowItem && allowItem == "image" && /*#__PURE__*/_jsxs("div", {
                  className: styles.text2,
                  children: ["Supports:", " ", allowItem && allowItem == "image" && "jpg, jpeg, png"]
                })]
              }), allowItem && allowItem == "pdf" && /*#__PURE__*/_jsxs(Fragment, {
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.text1,
                  children: "Brows your PDF here, or"
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.text2,
                  children: "Support: pdf"
                })]
              }), allowItem && allowItem == "xlsx" && /*#__PURE__*/_jsxs(Fragment, {
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.text1,
                  children: "Brows your XLSX here, or"
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.text2,
                  children: "Support: xlsx"
                })]
              }), allowItem && allowItem == "doc" && /*#__PURE__*/_jsxs(Fragment, {
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.text1,
                  children: "Brows your DOC here, or"
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.text2,
                  children: "Support: doc"
                })]
              })]
            })]
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Modal, {
      open: open,
      onClose: handleClose,
      "aria-labelledby": "modal-modal-title",
      "aria-describedby": "modal-modal-description",
      children: /*#__PURE__*/_jsxs(Box, {
        className: styles.ModalWrapper,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.ModalHead,
          children: [/*#__PURE__*/_jsx("h3", {
            className: styles.modal_title,
            children: " Media Library "
          }), /*#__PURE__*/_jsx("button", {
            className: styles.btnCloseModal,
            onClick: handleClose,
            children: /*#__PURE__*/_jsx(FiX, {})
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.filter_form,
          children: [!is_EnableForm && /*#__PURE__*/_jsxs("div", {
            id: "imgSearch",
            className: styles.serachArea,
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.search_left
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.search_right,
              children: [/*#__PURE__*/_jsxs("div", {
                className: styles.form_group,
                children: [/*#__PURE__*/_jsxs("select", {
                  className: styles.formControl,
                  name: "tag",
                  placeholder: "Filter by Type",
                  onChange: handleInput,
                  value: searchFields.filter.tag // onBlur={(e) => handleSearch()}
                  ,
                  children: [allowItem == "All" && /*#__PURE__*/_jsxs(Fragment, {
                    children: [/*#__PURE__*/_jsx("option", {
                      value: "",
                      children: "All Media"
                    }), /*#__PURE__*/_jsx("option", {
                      value: "image",
                      children: "Image"
                    }), /*#__PURE__*/_jsx("option", {
                      value: "pdf",
                      children: "PDF"
                    }), /*#__PURE__*/_jsx("option", {
                      value: "video",
                      children: "Video"
                    }), /*#__PURE__*/_jsx("option", {
                      value: "audio",
                      children: "Audio"
                    })]
                  }), allowItem == "image" && /*#__PURE__*/_jsx("option", {
                    value: "image",
                    children: "Image"
                  }), allowItem == "pdf" && /*#__PURE__*/_jsx("option", {
                    value: "pdf",
                    children: "PDF"
                  }), allowItem == "video" && /*#__PURE__*/_jsx("option", {
                    value: "video",
                    children: "Video"
                  }), allowItem == "audio" && /*#__PURE__*/_jsx("option", {
                    value: "audio",
                    children: "Audio"
                  })]
                }), /*#__PURE__*/_jsx("small", {
                  className: styles.formLebel,
                  children: "Filter by Type"
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.form_group,
                children: [/*#__PURE__*/_jsxs("select", {
                  className: styles.formControl,
                  name: "sortOrder",
                  placeholder: "Filter by Type",
                  onChange: handleOrder,
                  value: searchFields.sortOrder // onBlur={(e) => handleSearch()}
                  ,
                  children: [/*#__PURE__*/_jsx("option", {
                    value: "DESC",
                    children: "DESC"
                  }), /*#__PURE__*/_jsx("option", {
                    value: "ASC",
                    children: "ASC"
                  })]
                }), /*#__PURE__*/_jsx("small", {
                  className: styles.formLebel,
                  children: "Short Order"
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.form_group,
                children: [/*#__PURE__*/_jsx("span", {
                  className: styles.searchicon,
                  children: /*#__PURE__*/_jsx(FaSearch, {})
                }), /*#__PURE__*/_jsx("input", {
                  type: "text",
                  autoComplete: "off",
                  className: "".concat(styles.formControl, " ").concat(styles.keyword_search, " "),
                  name: "mediaName",
                  placeholder: "Search",
                  value: searchFields.searchText,
                  onChange: handleInput,
                  onKeyPress: function onKeyPress(e) {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleSearch();
                    }
                  },
                  onBlur: function onBlur(e) {
                    return handleSearch();
                  }
                }), /*#__PURE__*/_jsx("small", {
                  className: styles.formLebel,
                  children: "Filter by name"
                })]
              }), /*#__PURE__*/_jsx("div", {
                className: styles.form_group,
                children: /*#__PURE__*/_jsxs(Button, {
                  size: "small",
                  onClick: function onClick(e) {
                    return setEnableForm(true);
                  },
                  style: {
                    color: "#fff",
                    borderColor: "#F47F20",
                    backgroundColor: "#F47F20",
                    boxShadow: "none"
                  },
                  variant: "contained",
                  type: "button",
                  children: [/*#__PURE__*/_jsx(BsCloudUploadFill, {}), " \xA0", /*#__PURE__*/_jsx("span", {
                    className: "hide-sm",
                    children: "New"
                  })]
                })
              })]
            })]
          }), is_EnableForm && /*#__PURE__*/_jsx("div", {
            className: styles.serachArea,
            children: /*#__PURE__*/_jsxs(Button, {
              variant: "contained",
              size: "small",
              onClick: function onClick(e) {
                return handleList();
              },
              type: "button",
              style: {
                color: "#fff",
                borderColor: "#F47F20",
                backgroundColor: "#F47F20",
                boxShadow: "none",
                textTransform: "capitalize"
              },
              children: [/*#__PURE__*/_jsx(BsFillGrid3X2GapFill, {}), " \xA0 Back to Galary"]
            })
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.ModalBody,
          children: [!is_EnableForm && /*#__PURE__*/_jsx("div", {
            className: styles.grid_container,
            children: mediaData.length > 0 ? /*#__PURE__*/_jsx("div", {
              className: styles.grid_item,
              children: (loading ? Array.from(new Array(5)) : mediaData).map(function (entity, index) {
                if (entity) {
                  return /*#__PURE__*/_jsx(MediaBox, {
                    data: entity,
                    onClick: imageChange,
                    is_selected: selected && entity.mediaManagerId == selected.mediaManagerId
                  }, "media_".concat(entity.mediaManagerId));
                } else {
                  return /*#__PURE__*/_jsx(MediaScreen, {}, "media_".concat(index));
                }
              })
            }) : /*#__PURE__*/_jsx("div", {
              className: "no-result-fund"
            })
          }), is_EnableForm && /*#__PURE__*/_jsx(MediaUPload, {
            onUploaded: handleUploaded,
            allowItem: allowItem,
            showTitle: false
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.ModalFooter,
          children: [!is_EnableForm && paginate.total > paginate.page_total && /*#__PURE__*/_jsx("div", {
            className: styles.inputPager,
            children: /*#__PURE__*/_jsx(PaginationComponent, {
              paginate: paginate,
              paginationHandler: paginationHandler
            })
          }), !is_EnableForm && /*#__PURE__*/_jsxs("div", {
            className: styles.actions,
            children: [/*#__PURE__*/_jsx(Button, {
              onClick: handleClose,
              style: {
                marginLeft: "8px",
                background: "#F5F8FA",
                color: "#7E8299",
                boxShadow: "none"
              },
              type: "button",
              variant: "contained",
              size: "small",
              children: "Close"
            }), selected && selected.src && /*#__PURE__*/_jsx(Button, {
              variant: "contained",
              onClick: handleInsert,
              style: {
                marginLeft: "8px",
                background: "#F47F20",
                boxShadow: "none"
              },
              type: "button",
              size: "small",
              children: "Insert"
            })]
          }), is_EnableForm && /*#__PURE__*/_jsx(Grid, {
            item: true,
            md: 12,
            sm: 12,
            style: {
              textAlign: "right"
            },
            children: /*#__PURE__*/_jsx("button", {
              onClick: handleClose,
              className: styles.closeModal,
              type: "button",
              children: "Close"
            })
          })]
        })]
      })
    })]
  });
};
/* harmony default export */ var form_ImageInput = ((/* unused pure expression or super */ null && (ImageInput)));
// EXTERNAL MODULE: ./_unisearch/common/loader/course_screen.jsx
var course_screen = __webpack_require__(53469);
;// CONCATENATED MODULE: ./_unisearch/common/loader/index.js


;// CONCATENATED MODULE: ./_unisearch/common/form/MultipleFileInput.js





function MultipleFileInput_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MultipleFileInput_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MultipleFileInput_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MultipleFileInput_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable react-hooks/exhaustive-deps */

/* eslint-disable @next/next/no-img-element */













var MultipleFileInput = function MultipleFileInput(_ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? "Upload Files" : _ref$label,
      _ref$allowItem = _ref.allowItem,
      allowItem = _ref$allowItem === void 0 ? "image" : _ref$allowItem,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? [] : _ref$value,
      onChange = _ref.onChange;
  var FILES_URL = "/media-manager/find-mediaFile";

  var _useState = useState([]),
      fileData = _useState[0],
      setFileDate = _useState[1];

  var _useState2 = useState([]),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var _useState3 = useState(false),
      open = _useState3[0],
      setOpen = _useState3[1]; //on load or change value set file data


  useEffect(function () {
    setFileDate(value);
  }, [value]); //manage popup

  var handleOpen = function handleOpen(value) {
    setOpen(value);
  }; //loading and form


  var _useState4 = useState(false),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = useState(false),
      is_EnableForm = _useState5[0],
      setEnableForm = _useState5[1]; //get Media Data


  var _useState6 = useState([]),
      mediaData = _useState6[0],
      setMediaData = _useState6[1];

  var _useState7 = useState({}),
      paginate = _useState7[0],
      setPaginate = _useState7[1];

  var paginationHandler = function paginationHandler(event, page) {
    setSearchFields(MultipleFileInput_objectSpread(MultipleFileInput_objectSpread({}, searchFields), {}, {
      pageNumber: page
    }));
  }; //search search state


  var _useState8 = useState({
    filter: {
      mediaName: "",
      alt: "",
      tag: allowItem
    },
    sortOrder: "DESC",
    sortField: "mediaManagerId",
    pageNumber: 1,
    pageSize: 10
  }),
      searchFields = _useState8[0],
      setSearchFields = _useState8[1]; //handle serach input


  var handleInput = function handleInput(e) {
    var _e$target = e.target,
        name = _e$target.name,
        value = _e$target.value;

    var filter = MultipleFileInput_objectSpread(MultipleFileInput_objectSpread({}, searchFields.filter), {}, _defineProperty({}, name, value.trim()));

    setSearchFields(MultipleFileInput_objectSpread(MultipleFileInput_objectSpread({}, searchFields), {}, {
      filter: filter,
      pageNumber: 1
    }));
  };

  var handleOrder = function handleOrder(e) {
    var _objectSpread3;

    var _e$target2 = e.target,
        name = _e$target2.name,
        value = _e$target2.value;
    setSearchFields(MultipleFileInput_objectSpread(MultipleFileInput_objectSpread({}, searchFields), {}, (_objectSpread3 = {}, _defineProperty(_objectSpread3, name, value), _defineProperty(_objectSpread3, "pageNumber", 1), _objectSpread3)));
  }; //HANDLE SERARCH OBJECT


  var handleSearch = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              //loading true
              setLoading(true); //post handle search

              _context.next = 3;
              return API.post("".concat(FILES_URL), searchFields).then(function (response) {
                if (response.error) {
                  swalError("Something Wrong!");
                }

                if (!response.error) {
                  var _response$data = response.data,
                      total = _response$data.total,
                      results = _response$data.results,
                      currentPage = _response$data.currentPage,
                      page_total = _response$data.page_total,
                      limit = _response$data.limit; //set Paginate Info

                  setPaginate({
                    total: total,
                    currentPage: currentPage,
                    page_total: page_total,
                    limit: limit
                  }); //set media data

                  setMediaData(results);
                }
              })["catch"](function (error) {
                swalError(error);
              });

            case 3:
              //loading false
              setLoading(false);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSearch() {
      return _ref2.apply(this, arguments);
    };
  }();

  var imageChange = function imageChange(data) {
    var exist = selected && selected.filter(function (item) {
      return item.mediaManagerId == data.mediaManagerId;
    });

    if (exist && exist.length > 0) {
      setSelected(selected.filter(function (item) {
        return item.mediaManagerId != data.mediaManagerId;
      }));
    } else {
      setSelected(function (prev) {
        return [].concat(_toConsumableArray(prev), [data]);
      });
    }
  }; //insert data


  var handleInsert = function handleInsert(e) {
    e.preventDefault();
    var returnData = selected && selected.length > 0 ? selected.map(function (item) {
      return {
        mediaManagerId: item.mediaManagerId,
        src: item.src
      };
    }) : [];

    if (onChange) {
      onChange(returnData);
    }

    setOpen(false);
  };

  useEffect(function () {
    handleSearch();
  }, []); //when change page

  useEffect(function () {
    setTimeout(function () {
      handleSearch();
    }, 500);
  }, [searchFields]);
  useEffect(function () {
    setSelected(value);
  }, [value]); //when remove item

  var handleRemove = function handleRemove(id) {
    var returnDate = value.filter(function (item) {
      return item.mediaManagerId != id;
    });

    if (onChange) {
      onChange(returnDate);
    }
  }; //get data form child


  var handleUploaded = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(result) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!result) {
                _context2.next = 6;
                break;
              }

              setEnableForm(false);
              _context2.next = 4;
              return handleSearch();

            case 4:
              _context2.next = 7;
              break;

            case 6:
              swalError("Upload Error");

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleUploaded(_x) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.images_wrapper,
      children: [/*#__PURE__*/_jsx("label", {
        className: "admin_label",
        children: label
      }), /*#__PURE__*/_jsxs("ul", {
        className: styles.upload_images,
        children: [/*#__PURE__*/_jsx("li", {
          children: /*#__PURE__*/_jsx("button", {
            type: "button",
            htmlFor: "uploadImage",
            className: "".concat(styles.upload_image_child),
            onClick: function onClick(e) {
              handleOpen(true);
            },
            children: /*#__PURE__*/_jsx("img", {
              src: "/assets/images/admin/university/upload_image.jpg",
              alt: "Upload Image"
            })
          })
        }), fileData && fileData.length > 0 && fileData.map(function (item, i) {
          return /*#__PURE__*/_jsxs("li", {
            children: [/*#__PURE__*/_jsx("button", {
              type: "button",
              className: styles.image_delete,
              onClick: function onClick() {
                return handleRemove(item.mediaManagerId);
              },
              children: /*#__PURE__*/_jsx(FiX, {})
            }), /*#__PURE__*/_jsx("img", {
              src: item.src,
              alt: "gallery-image-".concat(i)
            })]
          }, "gallery_img_".concat(i));
        })]
      })]
    }), /*#__PURE__*/_jsx(Modal, {
      open: open,
      onClose: function onClose(e) {
        return handleOpen(false);
      },
      "aria-labelledby": "modal-modal-title",
      "aria-describedby": "modal-modal-description",
      children: /*#__PURE__*/_jsxs(Box, {
        className: styles.ModalWrapper,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.ModalHead,
          children: [/*#__PURE__*/_jsx("h3", {
            className: styles.modal_title,
            children: " Media Library "
          }), /*#__PURE__*/_jsx("button", {
            className: styles.btnCloseModal,
            onClick: function onClick() {
              return handleOpen(false);
            },
            children: /*#__PURE__*/_jsx(FiX, {})
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.filter_form,
          children: [!is_EnableForm && /*#__PURE__*/_jsxs("div", {
            className: styles.serachArea,
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.search_left,
              children: "\xA0"
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.search_right,
              children: [/*#__PURE__*/_jsxs("div", {
                className: styles.form_group,
                children: [/*#__PURE__*/_jsxs("select", {
                  className: styles.formControl,
                  name: "tag",
                  placeholder: "Filter by Type",
                  onChange: handleInput,
                  value: searchFields.filter.tag,
                  children: [allowItem == "All" && /*#__PURE__*/_jsxs(Fragment, {
                    children: [/*#__PURE__*/_jsx("option", {
                      value: "",
                      children: "All Media"
                    }), /*#__PURE__*/_jsx("option", {
                      value: "image",
                      children: "Image"
                    }), /*#__PURE__*/_jsx("option", {
                      value: "pdf",
                      children: "PDF"
                    }), /*#__PURE__*/_jsx("option", {
                      value: "video",
                      children: "Video"
                    }), /*#__PURE__*/_jsx("option", {
                      value: "audio",
                      children: "Audio"
                    })]
                  }), allowItem == "image" && /*#__PURE__*/_jsx("option", {
                    value: "image",
                    children: "Image"
                  }), allowItem == "pdf" && /*#__PURE__*/_jsx("option", {
                    value: "pdf",
                    children: "PDF"
                  }), allowItem == "video" && /*#__PURE__*/_jsx("option", {
                    value: "video",
                    children: "Video"
                  }), allowItem == "audio" && /*#__PURE__*/_jsx("option", {
                    value: "audio",
                    children: "Audio"
                  })]
                }), /*#__PURE__*/_jsx("small", {
                  className: styles.formLebel,
                  children: "Filter by Type"
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.form_group,
                children: [/*#__PURE__*/_jsxs("select", {
                  className: styles.formControl,
                  name: "sortOrder",
                  placeholder: "Filter by Type",
                  onChange: handleOrder,
                  value: searchFields.sortOrder,
                  children: [/*#__PURE__*/_jsx("option", {
                    value: "DESC",
                    children: "DESC"
                  }), /*#__PURE__*/_jsx("option", {
                    value: "ASC",
                    children: "ASC"
                  })]
                }), /*#__PURE__*/_jsx("small", {
                  className: styles.formLebel,
                  children: "Short Order"
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.form_group,
                children: [/*#__PURE__*/_jsx("span", {
                  className: styles.searchicon,
                  children: /*#__PURE__*/_jsx(FaSearch, {})
                }), /*#__PURE__*/_jsx("input", {
                  type: "text",
                  autoComplete: "off",
                  className: "".concat(styles.formControl, " ").concat(styles.keyword_search, " "),
                  name: "mediaName",
                  placeholder: "Search",
                  value: searchFields.searchText,
                  onChange: handleInput,
                  onKeyPress: function onKeyPress(e) {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleSearch();
                    }
                  },
                  onBlur: function onBlur(e) {
                    return handleSearch();
                  }
                }), /*#__PURE__*/_jsx("small", {
                  className: styles.formLebel,
                  children: "Filter by name"
                })]
              }), /*#__PURE__*/_jsx("div", {
                className: styles.form_group,
                children: /*#__PURE__*/_jsxs("button", {
                  size: "small",
                  onClick: function onClick(e) {
                    return setEnableForm(true);
                  },
                  type: "button",
                  className: "btn btn-primary",
                  children: [/*#__PURE__*/_jsx(BsCloudUploadFill, {}), /*#__PURE__*/_jsx("span", {
                    className: "hide-sm",
                    children: "New"
                  })]
                })
              })]
            })]
          }), is_EnableForm && /*#__PURE__*/_jsx("div", {
            className: styles.serachArea,
            children: /*#__PURE__*/_jsxs("button", {
              size: "small",
              onClick: function onClick(e) {
                return setEnableForm(true);
              },
              type: "button",
              children: [/*#__PURE__*/_jsx(BsFillGrid3X2GapFill, {}), " \xA0 Back to Galary"]
            })
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.ModalBody,
          children: [!is_EnableForm && /*#__PURE__*/_jsx("div", {
            className: styles.grid_container,
            children: /*#__PURE__*/_jsx("div", {
              className: styles.grid_item,
              children: mediaData && mediaData.length > 0 && mediaData.map(function (entity, index) {
                var slectedItem = selected.filter(function (item) {
                  return item.mediaManagerId == entity.mediaManagerId;
                });
                return /*#__PURE__*/_jsx(MediaBox, {
                  data: entity,
                  onClick: imageChange,
                  is_selected: slectedItem && slectedItem.length > 0 ? true : false
                }, "media_".concat(entity.mediaManagerId));
              })
            })
          }), is_EnableForm && /*#__PURE__*/_jsx(MediaUPload, {
            onUploaded: handleUploaded,
            allowItem: allowItem,
            showTitle: false
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.ModalFooter,
          children: [!is_EnableForm && paginate.total > paginate.page_total && /*#__PURE__*/_jsx("div", {
            className: styles.inputPager,
            children: /*#__PURE__*/_jsx(PaginationComponent, {
              paginate: paginate,
              paginationHandler: paginationHandler
            })
          }), !is_EnableForm && /*#__PURE__*/_jsxs("div", {
            className: styles.actions,
            children: [/*#__PURE__*/_jsx("button", {
              className: "btn btn-default",
              type: "button",
              onClick: function onClick() {
                return setOpen(false);
              },
              children: "Close"
            }), selected && selected.length > 0 && /*#__PURE__*/_jsx("button", {
              className: "btn btn-primary",
              variant: "contained",
              onClick: handleInsert,
              type: "button",
              size: "small",
              children: "Insert"
            })]
          }), is_EnableForm && /*#__PURE__*/_jsx("button", {
            className: "btn btn-default",
            onClick: function onClick() {
              return setOpen(false);
            },
            type: "button",
            children: "Close"
          })]
        })]
      })
    })]
  });
};
/* harmony default export */ var form_MultipleFileInput = ((/* unused pure expression or super */ null && (MultipleFileInput)));
;// CONCATENATED MODULE: ./_unisearch/common/form/sugessions.js





var UniSugessions = function UniSugessions(_ref) {
  var onChange = _ref.onChange,
      onClick = _ref.onClick;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      suggestions = _useState2[0],
      setSuggestions = _useState2[1];

  var _useState3 = useState(true),
      _useState4 = _slicedToArray(_useState3, 2),
      showSuggestions = _useState4[0],
      setShowSuggestions = _useState4[1];

  var handleChange = function handleChange(e) {
    var _e$target = _slicedToArray(e.target, 2),
        name = _e$target[0],
        value = _e$target[1];

    if (onChange) {
      onChange(e);
    } //sugession open


    setShowSuggestions(true);
  }; //handle outside


  useEffect(function (_ref2) {
    var onChange = _ref2.onChange;

    var checkIfClickedOutside = function checkIfClickedOutside(e) {
      if (showSuggestions && ref.current && !ref.current.contains(e.target)) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener("mousedown", checkIfClickedOutside);
    return function () {
      document.removeEventListener("mousedown", checkIfClickedOutside);
    };
  }, [showSuggestions]);
  return /*#__PURE__*/_jsxs("div", {
    className: "sugwrap",
    children: [/*#__PURE__*/_jsx("input", {
      type: "text",
      name: "location",
      className: styles.form_input,
      placeholder: "Enter Country, State",
      autoComplete: "off",
      onChange: handleChange,
      onClick: handleClick,
      value: value
    }), showSuggestions && suggestions && suggestions.length > 0 && /*#__PURE__*/_jsx("div", {
      className: styles.suggestions,
      children: /*#__PURE__*/_jsx("ul", {
        children: /*#__PURE__*/_jsx(FilterLocations, {})
      })
    })]
  });
};
/* harmony default export */ var sugessions = ((/* unused pure expression or super */ null && (UniSugessions)));
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.min.js
var react_datepicker_min = __webpack_require__(9198);
var react_datepicker_min_default = /*#__PURE__*/__webpack_require__.n(react_datepicker_min);
// EXTERNAL MODULE: ./node_modules/react-datepicker/dist/react-datepicker.css
var react_datepicker = __webpack_require__(95828);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./_unisearch/common/form/datepicker.module.scss
var datepicker_module = __webpack_require__(31118);
var datepicker_module_default = /*#__PURE__*/__webpack_require__.n(datepicker_module);
;// CONCATENATED MODULE: ./_unisearch/common/form/datePicker.js


var datePicker_moment = __webpack_require__(30381);







var DatePickerComponent = function DatePickerComponent(_ref) {
  var className = _ref.className,
      name = _ref.name,
      selected = _ref.selected,
      onSelect = _ref.onSelect,
      onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      onCalendarClose = _ref.onCalendarClose,
      onCalendarOpen = _ref.onCalendarOpen,
      onWeekSelect = _ref.onWeekSelect,
      onMonthChange = _ref.onMonthChange,
      onYearChange = _ref.onYearChange,
      onDayMouseEnter = _ref.onDayMouseEnter,
      min = _ref.min,
      max = _ref.max;

  var _useState = (0,react.useState)(),
      value = _useState[0],
      setValues = _useState[1];

  var _useState2 = (0,react.useState)(false),
      minDate = _useState2[0],
      setMinDate = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      maxDate = _useState3[0],
      setMaxDate = _useState3[1]; //on Select


  var handleSelect = function handleSelect(dateString) {
    var value = datePicker_moment(dateString);

    if (value.isValid()) {
      var target = {
        name: name,
        value: value.format("YYYY-MM-DD")
      };
      if (onSelect) onSelect({
        target: target
      });
    } else {
      var _target = {
        name: name,
        value: undefined
      };
      if (onSelect) onSelect({
        target: _target
      });
    }
  }; //on Change


  var handleChange = function handleChange(dateString) {
    var value = datePicker_moment(dateString);

    if (value.isValid()) {
      var target = {
        name: name,
        value: value.format("YYYY-MM-DD")
      };
      if (onChange) onChange({
        target: target
      });
    } else {
      var _target2 = {
        name: name,
        value: undefined
      };
      if (onChange) onChange({
        target: _target2
      });
    }
  }; //on blur


  var handleBlur = function handleBlur(dateString) {
    var value = datePicker_moment(dateString).format("YYYY-MM-DD");
    var target = {
      name: name,
      value: value
    };
    if (onBlur) onBlur({
      target: target
    });
  }; //on  Focus


  var handleFocus = function handleFocus(dateString) {
    var value = datePicker_moment(dateString).format("YYYY-MM-DD");
    var target = {
      name: name,
      value: value
    };
    if (onFocus) onFocus({
      target: target
    });
  }; //when week change


  var handleWeekSelect = function handleWeekSelect(e) {
    console.log("week select");
    console.log(e);
  }; //when month change


  var handleMonthChange = function handleMonthChange(e) {
    console.log("month select");
    console.log(e);
  }; //when year change


  var handleYearChange = function handleYearChange(e) {
    console.log("Year select");
    console.log(e);
  }; //when mouse hover


  var handleDayMouseEnter = function handleDayMouseEnter(e) {
    console.log("mouse enter");
    console.log(e);
  }; //disable input option on date picker


  var handleDateChangeRaw = function handleDateChangeRaw(e) {
    e.preventDefault();
  };

  (0,react.useEffect)(function () {
    if (selected && selected != "") {
      var selectedDate = datePicker_moment(selected);

      if (selectedDate.isValid()) {
        setValues(new Date(selectedDate));
      } else {
        setValues("");
      }
    } else {
      setValues("");
    }

    if (min) {
      var minumDate = datePicker_moment(min);

      if (minumDate.isValid()) {
        setMinDate(new Date(minumDate));
      }
    }

    if (max) {
      var maximumDate = datePicker_moment(max);

      if (maximumDate.isValid()) {
        setMaxDate(new Date(maximumDate));
      }
    }
  }, [selected, min, max]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: (datepicker_module_default()).pickearWrapper,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)((react_datepicker_min_default()), {
      className: className,
      name: name,
      selected: value,
      dateFormat: "dd/MM/yyyy",
      onChange: handleChange,
      onChangeRaw: handleDateChangeRaw,
      placeholderText: "dd/mm/yyyy" // onSelect={handleSelect}
      // onBlur={handleBlur}
      // onFocus={handleFocus}
      // onWeekSelect={handleWeekSelect}
      // onMonthChange={handleMonthChange}
      // onYearChange={handleYearChange}
      // onDayMouseEnter={handleDayMouseEnter}
      ,
      minDate: minDate ? minDate : "",
      maxDate: maxDate ? maxDate : "",
      autoComplete: "off",
      showYearDropdown: true,
      showMonthDropdown: true,
      dropdownMode: "scroll"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
      className: (datepicker_module_default()).pickerIcon,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* MdOutlineDateRange */.FFD, {})
    })]
  });
};
/* harmony default export */ var datePicker = ((/* unused pure expression or super */ null && (DatePickerComponent)));
;// CONCATENATED MODULE: ./_unisearch/common/form/uniEditor.jsx

 // const UniditEditor = React.lazy(() => {
//   return import("unidit-react");
// });




var importUnidit = function importUnidit() {
  return __webpack_require__.e(/* import() */ 6983).then(__webpack_require__.t.bind(__webpack_require__, 56712, 23));
};

var UniditEditor = dynamic_default()(importUnidit, {
  ssr: false
});
var buttons = ["undo", "redo", "|", "bold", "strikethrough", "underline", "italic", "|", "superscript", "subscript", "|", "align", "|", "ul", "ol", //   "outdent",
//   "indent",
"justify", "|", "font", "fontsize", "brush", "paragraph", "|", "image", "link", "table", "|", "hr", "eraser", "copyformat", "|", "fullsize", "selectall", "print", "|", "source", "|"];
var editorConfig = {
  readonly: false,
  toolbar: true,
  spellcheck: true,
  language: "en",
  toolbarButtonSize: "medium",
  toolbarAdaptive: false,
  showCharsCounter: true,
  showWordsCounter: true,
  showXPathInStatusbar: false,
  askBeforePasteHTML: true,
  askBeforePasteFromWord: true,
  // defaultActionOnPaste: "insert_clear_html",
  buttons: buttons,
  uploader: {
    insertImageAsBase64URI: true
  }
};
var UniEditor = function UniEditor(_ref) {
  var name = _ref.name,
      contents = _ref.contents,
      _onChange = _ref.onChange,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 100 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? "100%" : _ref$width,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? false : _ref$size,
      placeholder = _ref.placeholder;
  var editor = (0,react.useRef)(null);
  (0,react.useEffect)(function () {
    setValue(contents || "");
  }, [contents]);
  editorConfig.width = width;
  editorConfig.height = height;
  var initialContent = contents !== null && contents !== void 0 ? contents : "";

  var _useState = (0,react.useState)(initialContent),
      value = _useState[0],
      setValue = _useState[1];

  var isSSR = false;
  var target_name = name || "description";

  var _useState2 = (0,react.useState)(null),
      srcImage = _useState2[0],
      setSrc = _useState2[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: !isSSR && /*#__PURE__*/(0,jsx_runtime.jsx)(react.Suspense, {
      fallback: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: "Loading RTE"
      }),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(UniditEditor, {
        ref: editor,
        config: editorConfig,
        value: initialContent,
        onChange: function onChange(val) {
          setValue(val);

          if (_onChange) {
            var target = {
              name: target_name,
              value: val
            };

            _onChange({
              target: target
            });
          }
        }
      })
    })
  });
};
/* harmony default export */ var uniEditor = ((/* unused pure expression or super */ null && (UniEditor)));
;// CONCATENATED MODULE: ./_unisearch/common/form/uniEditorSmall.jsx



var uniEditorSmall_UniditEditor = /*#__PURE__*/react.lazy(function () {
  return __webpack_require__.e(/* import() */ 6983).then(__webpack_require__.t.bind(__webpack_require__, 56712, 23));
});
var uniEditorSmall_buttons = ["bold", "italic", "underline", "align", "ul", "ol"];
var uniEditorSmall_editorConfig = {
  readonly: false,
  toolbar: true,
  spellcheck: true,
  language: "en",
  toolbarButtonSize: "medium",
  toolbarAdaptive: false,
  showCharsCounter: true,
  showWordsCounter: true,
  showXPathInStatusbar: false,
  askBeforePasteHTML: true,
  askBeforePasteFromWord: true,
  defaultActionOnPaste: "insert_clear_html",
  buttons: uniEditorSmall_buttons
};
var UniEditorSmall = function UniEditorSmall(_ref) {
  var name = _ref.name,
      contents = _ref.contents,
      _onChange = _ref.onChange,
      _onBlur = _ref.onBlur,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 100 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? "100%" : _ref$width,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? false : _ref$size,
      placeholder = _ref.placeholder;
  uniEditorSmall_editorConfig.width = width;
  uniEditorSmall_editorConfig.height = height;
  var initialContent = contents !== null && contents !== void 0 ? contents : "";

  var _useState = (0,react.useState)(initialContent),
      value = _useState[0],
      setValue = _useState[1];

  var isSSR = false;
  var target_name = name || "description";
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: !isSSR && /*#__PURE__*/(0,jsx_runtime.jsx)(react.Suspense, {
      fallback: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        children: "Loading RTE"
      }),
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(uniEditorSmall_UniditEditor, {
        config: uniEditorSmall_editorConfig,
        value: initialContent,
        onBlur: function onBlur(val) {
          setValue(val);

          if (_onBlur) {
            var target = {
              name: target_name,
              value: val
            };

            _onBlur({
              target: target
            });
          }
        },
        onChange: function onChange(val) {
          setValue(val);

          if (_onChange) {
            var target = {
              name: target_name,
              value: val
            };

            _onChange({
              target: target
            });
          }
        }
      })
    })
  });
};
/* harmony default export */ var uniEditorSmall = ((/* unused pure expression or super */ null && (UniEditorSmall)));
;// CONCATENATED MODULE: ./_unisearch/common/form/uniEditorMedium.jsx



var uniEditorMedium_UniditEditor = /*#__PURE__*/(/* unused pure expression or super */ null && (React.lazy(function () {
  return __webpack_require__.e(/* import() */ 6983).then(__webpack_require__.t.bind(__webpack_require__, 56712, 23));
})));
var uniEditorMedium_buttons = ["undo", "redo", "|", "bold", "strikethrough", "underline", "italic", "|", "superscript", "subscript", "|", "align", "|", "ul", "ol", //   "outdent",
//   "indent",
"justify", "|", "font", "fontsize", "brush", "paragraph", "|"];
var uniEditorMedium_editorConfig = {
  readonly: false,
  toolbar: true,
  spellcheck: true,
  language: "en",
  toolbarButtonSize: "medium",
  toolbarAdaptive: false,
  showCharsCounter: true,
  showWordsCounter: true,
  showXPathInStatusbar: false,
  askBeforePasteHTML: true,
  askBeforePasteFromWord: true,
  defaultActionOnPaste: "insert_clear_html",
  buttons: uniEditorMedium_buttons
};
var UniEditorMedium = function UniEditorMedium(_ref) {
  var name = _ref.name,
      contents = _ref.contents,
      _onChange = _ref.onChange,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 100 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? "100%" : _ref$width,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? false : _ref$size,
      placeholder = _ref.placeholder;
  uniEditorMedium_editorConfig.width = width;
  uniEditorMedium_editorConfig.height = height;
  var initialContent = contents !== null && contents !== void 0 ? contents : "";

  var _useState = useState(initialContent),
      value = _useState[0],
      setValue = _useState[1];

  var isSSR = false;
  var target_name = name || "description";
  return /*#__PURE__*/_jsx(_Fragment, {
    children: !isSSR && /*#__PURE__*/_jsx(React.Suspense, {
      fallback: /*#__PURE__*/_jsx("div", {
        children: "Loading RTE"
      }),
      children: /*#__PURE__*/_jsx(uniEditorMedium_UniditEditor, {
        config: uniEditorMedium_editorConfig,
        value: initialContent,
        onChange: function onChange(val) {
          setValue(val);

          if (_onChange) {
            var target = {
              name: target_name,
              value: val
            };

            _onChange({
              target: target
            });
          }
        }
      })
    })
  });
};
/* harmony default export */ var uniEditorMedium = ((/* unused pure expression or super */ null && (UniEditorMedium)));
;// CONCATENATED MODULE: ./_unisearch/common/form/MyGallery.js





function MyGallery_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MyGallery_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MyGallery_ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MyGallery_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




















var MyGallery_style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4
};
var MyGallery_MyGallery = function MyGallery(_ref) {
  var name = _ref.name,
      url = _ref.url,
      onChange = _ref.onChange,
      returnItem = _ref.returnItem,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? false : _ref$value,
      _ref$component_type = _ref.component_type,
      component_type = _ref$component_type === void 0 ? "default" : _ref$component_type,
      guideLine = _ref.guideLine,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? "Upload Image" : _ref$title,
      _ref$allowItem = _ref.allowItem,
      allowItem = _ref$allowItem === void 0 ? "image" : _ref$allowItem;

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1]; //handle open


  var handleOpen = function handleOpen(data) {
    setOpen(data);
  }; //handle close


  var handleClose = function handleClose(e) {
    e.preventDefault();
    setOpen(false);
  }; //initial media name and files


  var target_name = name || "featured_image";
  var FILES_URL = "/media-manager/find-mediaFile";

  var _useState = useState(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useState2 = useState(false),
      is_EnableForm = _useState2[0],
      setEnableForm = _useState2[1]; //get Media Data


  var _useState3 = useState([]),
      mediaData = _useState3[0],
      setMediaData = _useState3[1];

  var _useState4 = useState({}),
      paginate = _useState4[0],
      setPaginate = _useState4[1]; //search search state


  var _useState5 = useState({
    filter: {
      mediaName: "",
      alt: "",
      tag: allowItem
    },
    sortOrder: "DESC",
    sortField: "mediaManagerId",
    pageNumber: 1,
    pageSize: 10
  }),
      searchFields = _useState5[0],
      setSearchFields = _useState5[1];

  var paginationHandler = function paginationHandler(event, page) {
    setSearchFields(MyGallery_objectSpread(MyGallery_objectSpread({}, searchFields), {}, {
      pageNumber: page
    }));
  }; //handle serach input


  var handleInput = function handleInput(e) {
    var _e$target = e.target,
        name = _e$target.name,
        value = _e$target.value;

    var filter = MyGallery_objectSpread(MyGallery_objectSpread({}, searchFields.filter), {}, _defineProperty({}, name, value));

    setSearchFields(MyGallery_objectSpread(MyGallery_objectSpread({}, searchFields), {}, {
      filter: filter,
      pageNumber: 1
    }));
  };

  var handleOrder = function handleOrder(e) {
    var _objectSpread3;

    var _e$target2 = e.target,
        name = _e$target2.name,
        value = _e$target2.value;
    setSearchFields(MyGallery_objectSpread(MyGallery_objectSpread({}, searchFields), {}, (_objectSpread3 = {}, _defineProperty(_objectSpread3, name, value), _defineProperty(_objectSpread3, "pageNumber", 1), _objectSpread3)));
  }; //when click on handle serach button


  var handleSearch = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              //loading true
              setLoading(true); //post handle search

              _context.next = 3;
              return API.post("".concat(FILES_URL), searchFields).then(function (response) {
                if (response.error) {
                  swalError("Something Wrong!");
                }

                if (!response.error) {
                  var _response$data = response.data,
                      total = _response$data.total,
                      results = _response$data.results,
                      currentPage = _response$data.currentPage,
                      page_total = _response$data.page_total,
                      limit = _response$data.limit; //set Paginate Info

                  setPaginate({
                    total: total,
                    currentPage: currentPage,
                    page_total: page_total,
                    limit: limit
                  }); //set media data

                  setMediaData(results);
                }
              })["catch"](function (error) {
                swalError(error);
              });

            case 3:
              //loading false
              setLoading(false);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSearch() {
      return _ref2.apply(this, arguments);
    };
  }(); //Manage image path


  var placeholder = allowItem && allowItem == "video" ? "/assets/images/vector-image.png" : "/assets/images/vector-image.png";

  var _useState6 = useState(placeholder),
      imageUrl = _useState6[0],
      setImageUrl = _useState6[1];

  var _useState7 = useState(),
      selected = _useState7[0],
      setSelected = _useState7[1];

  var imageChange = function imageChange(data) {
    if (selected && selected.mediaManagerId == data.mediaManagerId) {
      setSelected("");
    } else {
      setSelected(data);
    }
  };

  var handleInsert = function handleInsert() {
    setImageUrl(selected.src); //pass parent props

    if (onChange) {
      var target = {
        name: target_name,
        value: selected[returnItem]
      };
      onChange({
        target: target
      });
    }

    setOpen(false);
  };

  var PreviewImage = function PreviewImage(imageUrl) {
    var extension = imageUrl.split(".").pop();

    if (extension == "pdf") {
      return /*#__PURE__*/_jsx(ReactSVG, {
        className: styles.icon,
        src: getAssets("assets/icons/pdf_icon.svg")
      });
    }

    if (extension == "xlsx" || extension == "xls") {
      return /*#__PURE__*/_jsx(ReactSVG, {
        className: styles.icon,
        src: getAssets("assets/icons/xls_icon.svg")
      });
    }

    if (extension == "docx" || extension == "doc") {
      return /*#__PURE__*/_jsx(ReactSVG, {
        className: styles.icon,
        src: getAssets("assets/icons/doc_icon.svg")
      });
    }

    if (extension == "mp4") {
      return /*#__PURE__*/_jsxs("video", {
        width: "100%",
        height: "180",
        controls: "controls",
        preload: "none",
        children: [/*#__PURE__*/_jsx("source", {
          src: imageUrl,
          type: "video/mp4",
          autostart: "false"
        }), "Your browser does not support the video tag."]
      });
    }

    if (extension == "jpg" || extension == "jpeg" || extension == "png" || extension == "webp" || extension == "svg") {
      return /*#__PURE__*/_jsxs("div", {
        className: styles.media_image_wrapper,
        children: [/*#__PURE__*/_jsx("img", {
          src: imageUrl,
          alt: ""
        }), imageUrl === "/assets/images/vector-image.png" ? /*#__PURE__*/_jsx(HiPlusCircle, {
          className: "admin_upload_image_icon"
        }) : null]
      });
    }

    return /*#__PURE__*/_jsx("img", {
      src: imageUrl,
      alt: ""
    });
  }; //when change page


  useEffect(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!open) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return handleSearch();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function fetchData() {
        return _ref3.apply(this, arguments);
      };
    }();

    fetchData();
  }, [searchFields.pageNumber, searchFields.sortOrder]);
  useEffect(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(open && mediaData.length <= 0)) {
                  _context3.next = 3;
                  break;
                }

                _context3.next = 3;
                return handleSearch();

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function fetchData() {
        return _ref4.apply(this, arguments);
      };
    }();

    fetchData();
  }, [open]); //change image url

  useEffect(function () {
    if (url) {
      setImageUrl(url);
    } else {
      setImageUrl(placeholder);
    }
  }, [url, placeholder]); //handleList

  var handleList = function handleList() {
    setEnableForm(false);
  }; //get data form child


  var handleUploaded = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(result) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!result) {
                _context4.next = 6;
                break;
              }

              setEnableForm(false);
              _context4.next = 4;
              return handleSearch();

            case 4:
              _context4.next = 7;
              break;

            case 6:
              swalError("Upload Error");

            case 7:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function handleUploaded(_x) {
      return _ref5.apply(this, arguments);
    };
  }(); //remove this item


  var handleRemove = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (selected && selected.mediaManagerId) {
                swalConfirm("you want to remove this item?", "Are you sure", "Yes Remove").then( /*#__PURE__*/function () {
                  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(res) {
                    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            if (!res.isConfirmed) {
                              _context6.next = 3;
                              break;
                            }

                            _context6.next = 3;
                            return API["delete"]("media-manager/delete/".concat(parseInt(selected.mediaManagerId))).then( /*#__PURE__*/function () {
                              var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(res) {
                                var pageNumber;
                                return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                                  while (1) {
                                    switch (_context5.prev = _context5.next) {
                                      case 0:
                                        pageNumber = paginate.page_total >= 2 ? paginate.currentPage : paginate.currentPage > 1 && paginate.page_total == 1 ? parseInt(paginate.currentPage - 1) : paginate.currentPage; //clear selected state

                                        setSelected(""); //search again

                                        setSearchFields(MyGallery_objectSpread(MyGallery_objectSpread({}, searchFields), {}, {
                                          pageNumber: pageNumber
                                        }));

                                        if (!(pageNumber == paginate.currentPage)) {
                                          _context5.next = 6;
                                          break;
                                        }

                                        _context5.next = 6;
                                        return handleSearch();

                                      case 6:
                                      case "end":
                                        return _context5.stop();
                                    }
                                  }
                                }, _callee5);
                              }));

                              return function (_x3) {
                                return _ref8.apply(this, arguments);
                              };
                            }());

                          case 3:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6);
                  }));

                  return function (_x2) {
                    return _ref7.apply(this, arguments);
                  };
                }());
              } else {
                swalError("Please select any one media item");
              }

            case 1:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function handleRemove() {
      return _ref6.apply(this, arguments);
    };
  }(); //remove selected items from state


  var handleClear = function handleClear() {
    swalConfirm("Remove this item", "Are you sure", "Yes Delete").then(function (rsp) {
      if (rsp.isConfirmed) {
        setImageUrl(placeholder);
        setSelected("");

        if (onChange) {
          var target = {
            name: "",
            value: ""
          };
          onChange({
            target: target
          });
        }
      }
    });
  };

  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("button", {
      onClick: function onClick(e) {
        return handleOpen(true);
      },
      type: "button",
      name: target_name,
      "data-srclink": imageUrl !== null && imageUrl !== void 0 ? imageUrl : 0,
      style: {
        display: "none"
      }
    }), value && value != undefined && value != 0 && /*#__PURE__*/_jsxs("button", {
      type: "button",
      className: styles.clearOld,
      onClick: function onClick() {
        return handleClear();
      },
      children: [/*#__PURE__*/_jsx(FaTrash, {}), " ", /*#__PURE__*/_jsx("span", {
        className: "hide-sm"
      })]
    }), /*#__PURE__*/_jsx(Modal, {
      open: open,
      onClose: handleClose,
      "aria-labelledby": "modal-modal-title",
      "aria-describedby": "modal-modal-description",
      children: /*#__PURE__*/_jsxs(Box, {
        className: styles.ModalWrapper,
        children: [/*#__PURE__*/_jsxs("div", {
          className: styles.ModalHead,
          children: [/*#__PURE__*/_jsx("h3", {
            className: styles.modal_title,
            children: " Media Library "
          }), /*#__PURE__*/_jsx("button", {
            className: styles.btnCloseModal,
            onClick: handleClose,
            children: /*#__PURE__*/_jsx(FiX, {})
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.filter_form,
          children: [!is_EnableForm && /*#__PURE__*/_jsxs("div", {
            id: "imgSearch",
            className: styles.serachArea,
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.search_left,
              children: " "
            }), /*#__PURE__*/_jsxs("div", {
              className: styles.search_right,
              children: [/*#__PURE__*/_jsxs("div", {
                className: styles.form_group,
                children: [/*#__PURE__*/_jsxs("select", {
                  className: styles.formControl,
                  name: "tag",
                  placeholder: "Filter by Type",
                  onChange: handleInput,
                  value: searchFields.filter.tag // onBlur={(e) => handleSearch()}
                  ,
                  children: [allowItem == "All" && /*#__PURE__*/_jsxs(Fragment, {
                    children: [/*#__PURE__*/_jsx("option", {
                      value: "",
                      children: "All Media"
                    }), /*#__PURE__*/_jsx("option", {
                      value: "image",
                      children: "Image"
                    }), /*#__PURE__*/_jsx("option", {
                      value: "pdf",
                      children: "PDF"
                    }), /*#__PURE__*/_jsx("option", {
                      value: "video",
                      children: "Video"
                    })]
                  }), allowItem == "image" && /*#__PURE__*/_jsx("option", {
                    value: "image",
                    children: "Image"
                  }), allowItem == "pdf" && /*#__PURE__*/_jsx("option", {
                    value: "pdf",
                    children: "PDF"
                  }), allowItem == "video" && /*#__PURE__*/_jsx("option", {
                    value: "video",
                    children: "Video"
                  }), allowItem == "audio" && /*#__PURE__*/_jsx("option", {
                    value: "audio",
                    children: "Audio"
                  })]
                }), /*#__PURE__*/_jsx("small", {
                  className: styles.formLebel,
                  children: "Filter by Type"
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.form_group,
                children: [/*#__PURE__*/_jsxs("select", {
                  className: styles.formControl,
                  name: "sortOrder",
                  placeholder: "Filter by Type",
                  onChange: handleOrder,
                  value: searchFields.sortOrder // onBlur={(e) => handleSearch()}
                  ,
                  children: [/*#__PURE__*/_jsx("option", {
                    value: "DESC",
                    children: "DESC"
                  }), /*#__PURE__*/_jsx("option", {
                    value: "ASC",
                    children: "ASC"
                  })]
                }), /*#__PURE__*/_jsx("small", {
                  className: styles.formLebel,
                  children: "Short Order"
                })]
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.form_group,
                children: [/*#__PURE__*/_jsx("span", {
                  className: styles.searchicon,
                  children: /*#__PURE__*/_jsx(FaSearch, {})
                }), /*#__PURE__*/_jsx("input", {
                  type: "text",
                  autoComplete: "off",
                  className: "".concat(styles.formControl, " ").concat(styles.keyword_search, " "),
                  name: "mediaName",
                  placeholder: "Search",
                  value: searchFields.searchText,
                  onChange: handleInput,
                  onKeyPress: function onKeyPress(e) {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      handleSearch();
                    }
                  },
                  onBlur: function onBlur(e) {
                    return handleSearch();
                  }
                }), /*#__PURE__*/_jsx("small", {
                  className: styles.formLebel,
                  children: "Filter by name"
                })]
              }), /*#__PURE__*/_jsx("div", {
                className: styles.form_group,
                children: /*#__PURE__*/_jsxs(Button, {
                  size: "small",
                  onClick: function onClick(e) {
                    return setEnableForm(true);
                  },
                  style: {
                    color: "#fff",
                    borderColor: "#F47F20",
                    backgroundColor: "#F47F20",
                    boxShadow: "none"
                  },
                  variant: "contained",
                  type: "button",
                  children: [/*#__PURE__*/_jsx(BsCloudUploadFill, {}), " \xA0", /*#__PURE__*/_jsx("span", {
                    className: "hide-sm",
                    children: "New"
                  })]
                })
              })]
            })]
          }), is_EnableForm && /*#__PURE__*/_jsx("div", {
            className: styles.serachArea,
            children: /*#__PURE__*/_jsxs(Button, {
              variant: "contained",
              size: "small",
              onClick: function onClick(e) {
                return handleList();
              },
              type: "button",
              style: {
                color: "#fff",
                borderColor: "#F47F20",
                backgroundColor: "#F47F20",
                boxShadow: "none",
                textTransform: "capitalize"
              },
              children: [/*#__PURE__*/_jsx(BsFillGrid3X2GapFill, {}), " \xA0 Back to Galary"]
            })
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.ModalBody,
          children: [!is_EnableForm && /*#__PURE__*/_jsx("div", {
            className: styles.grid_container,
            children: mediaData.length > 0 ? /*#__PURE__*/_jsx("div", {
              className: styles.grid_item,
              children: (loading ? Array.from(new Array(5)) : mediaData).map(function (entity, index) {
                if (entity) {
                  return /*#__PURE__*/_jsx(MediaBox, {
                    data: entity,
                    onClick: imageChange,
                    is_selected: selected && entity.mediaManagerId == selected.mediaManagerId
                  }, "media_".concat(entity.mediaManagerId));
                } else {
                  return /*#__PURE__*/_jsx(MediaScreen, {}, "media_".concat(index));
                }
              })
            }) : /*#__PURE__*/_jsx("div", {
              className: "no-result-fund"
            })
          }), is_EnableForm && /*#__PURE__*/_jsx(MediaUPload, {
            onUploaded: handleUploaded,
            allowItem: allowItem,
            showTitle: false
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.ModalFooter,
          children: [!is_EnableForm && paginate.total > paginate.page_total && /*#__PURE__*/_jsx("div", {
            className: styles.inputPager,
            children: /*#__PURE__*/_jsx(PaginationComponent, {
              paginate: paginate,
              paginationHandler: paginationHandler
            })
          }), !is_EnableForm && /*#__PURE__*/_jsxs("div", {
            className: styles.actions,
            children: [/*#__PURE__*/_jsx(Button, {
              onClick: handleClose,
              style: {
                marginLeft: "8px",
                background: "#F5F8FA",
                color: "#7E8299",
                boxShadow: "none"
              },
              type: "button",
              variant: "contained",
              size: "small",
              children: "Close"
            }), /*#__PURE__*/_jsx(Button, {
              name: "insertimages",
              variant: "contained",
              "data-srclink": selected && selected.src ? selected.src : imageUrl,
              onClick: handleInsert,
              style: {
                marginLeft: "8px",
                background: "#F47F20",
                boxShadow: "none",
                display: selected && selected.src ? "inline" : "none"
              },
              type: "button",
              size: "small",
              children: "Insert"
            })]
          }), is_EnableForm && /*#__PURE__*/_jsx(Grid, {
            item: true,
            md: 12,
            sm: 12,
            style: {
              textAlign: "right"
            },
            children: /*#__PURE__*/_jsx("button", {
              onClick: handleClose,
              className: styles.closeModal,
              type: "button",
              children: "Close"
            })
          })]
        })]
      })
    })]
  });
};
/* harmony default export */ var form_MyGallery = ((/* unused pure expression or super */ null && (MyGallery_MyGallery)));
;// CONCATENATED MODULE: ./_unisearch/common/form/uniEditorDefault.jsx


var imageLinkSource = "s";

var uniEditorDefault_importUnidit = function importUnidit() {
  return __webpack_require__.e(/* import() */ 6983).then(__webpack_require__.t.bind(__webpack_require__, 56712, 23));
};

var uniEditorDefault_UniditEditor = dynamic_default()(uniEditorDefault_importUnidit, {
  ssr: false
});





function called() {
  var data = document.querySelector('button[name="insertimages"]').getAttribute("data-srclink"); // console.log(arguments[0].s.insertImage(data));
  // arguments[0].e.s.insertHtml("ddd");
}

var fileBrows = function fileBrows(editor) {
  document.querySelector('button[name="uniImageUploader"]').click();
  document.querySelector('button[name="insertimages"]').addEventListener("click", called.bind(editor, editor));
};
var fileBrows2 = function fileBrows2(editor) {
  document.querySelector('button[name="uniImageUploader"]').click();
  document.querySelector('button[name="insertimages"]').addEventListener("click", function () {
    var data = document.querySelector('button[name="insertimages"]').getAttribute("data-srclink");

    if (data != null && data != "undefined" && data != "") {
      var img = "<img src=\"" + data + "\" alt=\"ddd\" width=\"300px\">"; // console.log(editor);
      // editor1.s.insertHTML(`<p>` + img + `</p>`);
    }
  });
};
var fileBrows1 = function fileBrows1(editor) {
  var editor1 = editor;
  document.querySelector('button[name="uniImageUploader"]').click();
  document.querySelector('button[name="insertimages"]').addEventListener("click", function () {
    document.querySelector('button[name="insertimages"]').addEventListener("click", function () {
      if (data != null && data != "undefined" && data != "") {
        imageLinkSource = "<p>" + data + "</p>";
        return;
      } else {
        return false;
      }
    });
  }); // editor.s.insertHTML("hello");
  // editor.s.insertHTML("ddd");
  //   let data = document
  //   .querySelector('button[name="insertimages"]')
  //   .getAttribute("data-srclink");
  // if (data != null && data != "undefined" && data != "") {
  //   let img = `<p><img src="` + data + `"  width="300px"></p>`;
  //   console.log(editor.selection.insertHTML("dd"));
  //   // editor.s.insertHTML(`<p>` + img + `</p>`);
  //   return;
  // } else {
  //   return false;
  // }
};
var uniEditorDefault_buttons = ["undo", "redo", "|", "bold", "strikethrough", "underline", "italic", "|", "superscript", "subscript", "|", "align", "|", "ul", "ol", //   "outdent",
//   "indent",
"justify", "|", "font", "fontsize", "brush", "paragraph", "|", "image", {
  name: "gallery",
  tooltip: "Uni gallery",
  iconURL: "data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSIyNHB4IiBoZWlnaHQ9IjI0cHgiIHZpZXdCb3g9IjAgMCAyNCAyNCIgdmVyc2lvbj0iMS4xIj48dGl0bGU+UGhvdG88L3RpdGxlPjxnIGlkPSJQaG90byIgc3Ryb2tlPSIjNEE0QTRBIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PHJlY3QgaWQ9IlJlY3RhbmdsZS0xNiIgeD0iMi41IiB5PSIyLjUiIHdpZHRoPSIxOSIgaGVpZ2h0PSIxOSIgcng9IjIiLz48cGF0aCBpZD0iUGF0aC05IiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBkPSJNNC44NjggMTlsMy43NjYtOS4wNDggNC4yMyA3LjQzNiAyLjQwNC00LjAwN0wxOS4wNjIgMTl6Ii8+PGNpcmNsZSBpZD0iT3ZhbCIgY3g9IjE2IiBjeT0iNy4xMzMzMzMzMyIgcj0iMi4xMzMzMzMzMyIvPjwvZz48bWV0YWRhdGE+PHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIiB4bWxuczpyZGZzPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwLzAxL3JkZi1zY2hlbWEjIiB4bWxuczpkYz0iaHR0cDovL3B1cmwub3JnL2RjL2VsZW1lbnRzLzEuMS8iPjxyZGY6RGVzY3JpcHRpb24gYWJvdXQ9Imh0dHBzOi8vaWNvbnNjb3V0LmNvbS9sZWdhbCNsaWNlbnNlcyIgZGM6dGl0bGU9InBob3RvIiBkYzpkZXNjcmlwdGlvbj0icGhvdG8iIGRjOnB1Ymxpc2hlcj0iSWNvbnNjb3V0IiBkYzpkYXRlPSIyMDE4LTA2LTI4IiBkYzpmb3JtYXQ9ImltYWdlL3N2Zyt4bWwiIGRjOmxhbmd1YWdlPSJlbiI+PGRjOmNyZWF0b3I+PHJkZjpCYWc+PHJkZjpsaT5BdmluYXNoIFA8L3JkZjpsaT48L3JkZjpCYWc+PC9kYzpjcmVhdG9yPjwvcmRmOkRlc2NyaXB0aW9uPjwvcmRmOlJERj48L21ldGFkYXRhPjwvc3ZnPg==",
  exec: function exec(editor) {
    fileBrows(editor);
  }
}, "link", "table", "|", "hr", "eraser", "copyformat", "|", "selectall", "print", "|", "source", "|", "fullsize"];
var uniEditorDefault_editorConfig = {
  readonly: false,
  // events: {  afterInit: (instance) => {
  //   editorInstance = instance
  // } },
  toolbar: true,
  spellcheck: true,
  language: "en",
  toolbarButtonSize: "medium",
  toolbarAdaptive: false,
  showCharsCounter: true,
  showWordsCounter: true,
  showXPathInStatusbar: false,
  askBeforePasteHTML: true,
  askBeforePasteFromWord: true,
  //defaultActionOnPaste: "insert_clear_html",
  buttons: uniEditorDefault_buttons,
  uploader: {
    insertImageAsBase64URI: true
  },
  width: 800,
  height: 300
};
var UniEditorDefault = function UniEditorDefault(_ref) {
  var name = _ref.name,
      contents = _ref.contents,
      _onChange = _ref.onChange,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 100 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? "100%" : _ref$width,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? false : _ref$size,
      placeholder = _ref.placeholder;
  var editor = useRef(null);
  useEffect(function () {
    setValue(contents || "");
  }, [contents]);
  uniEditorDefault_editorConfig.width = width;
  uniEditorDefault_editorConfig.height = height;
  var initialContent = contents !== null && contents !== void 0 ? contents : "";

  var _useState = useState(initialContent),
      value = _useState[0],
      setValue = _useState[1];

  var isSSR = false;
  var target_name = name || "description";

  var _useState2 = useState(null),
      srcImage = _useState2[0],
      setSrc = _useState2[1];

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!isSSR && /*#__PURE__*/_jsx(React.Suspense, {
      fallback: /*#__PURE__*/_jsx("div", {
        children: "Loading RTE"
      }),
      children: /*#__PURE__*/_jsx(uniEditorDefault_UniditEditor, {
        ref: editor,
        config: uniEditorDefault_editorConfig,
        value: initialContent,
        onChange: function onChange(val) {
          setValue(val);

          if (_onChange) {
            var target = {
              name: target_name,
              value: val
            };

            _onChange({
              target: target
            });
          }
        }
      })
    }), /*#__PURE__*/_jsx(MyGallery, {
      name: "uniImageUploader",
      onChange: function onChange(event) {
        setSrc(event.target.src);
      }
    })]
  });
};
/* harmony default export */ var uniEditorDefault = ((/* unused pure expression or super */ null && (UniEditorDefault)));
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment_moment = __webpack_require__(30381);
// EXTERNAL MODULE: ./node_modules/react-date-range/dist/index.js
var dist = __webpack_require__(30286);
// EXTERNAL MODULE: ./node_modules/react-date-range/dist/styles.css
var dist_styles = __webpack_require__(64055);
// EXTERNAL MODULE: ./node_modules/react-date-range/dist/theme/default.css
var theme_default = __webpack_require__(41059);
;// CONCATENATED MODULE: ./_unisearch/common/form/dateRangePicker.js

var _excluded = (/* unused pure expression or super */ null && (["name", "value", "setFieldValue"]));

/* eslint-disable react-hooks/exhaustive-deps */









var dateRangePicker_DateRangeComponent = function DateRangeComponent(_ref) {
  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? "date_range" : _ref$name,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? "" : _ref$value,
      setFieldValue = _ref.setFieldValue,
      props = _objectWithoutProperties(_ref, _excluded);

  var ref = useRef(null);

  var _useState = useState(false),
      is_open = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = useState(),
      selectionRange = _useState2[0],
      setSelectionRange = _useState2[1]; //on change values


  useEffect(function () {
    if (value && value != "") {
      var range = value.split(" - ");
      setSelectionRange([{
        startDate: new Date(),
        endDate: new Date(),
        key: "selection"
      }]);
    } else {
      setSelectionRange([{
        startDate: new Date(),
        endDate: new Date(),
        key: "selection"
      }]);
    }
  }, []); //return values

  useEffect(function () {
    if (selectionRange && selectionRange.length > 0) {
      var startDate = selectionRange[0].startDate;
      var endDate = selectionRange[0].endDate;
      var returnVal = "".concat(moment(startDate).format("YYYY/MM/DD"), " - ").concat(moment(endDate).format("YYYY/MM/DD"));

      if (setFieldValue) {
        setFieldValue(name, returnVal);
      }
    }
  }, [selectionRange]); //handle open datepicker

  var handleOpen = function handleOpen() {
    setIsOpen(true);
  }; //handle outside click


  useEffect(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside, true);
    return function () {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.daterange_wraper,
    ref: ref,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.range_selector,
      onClick: function onClick() {
        return handleOpen();
      },
      children: [/*#__PURE__*/_jsx("span", {
        children: value !== null && value !== void 0 ? value : ""
      }), /*#__PURE__*/_jsx(AiOutlineCalendar, {})]
    }), is_open && /*#__PURE__*/_jsx(DateRange, {
      onChange: function onChange(item) {
        return setSelectionRange([item.selection]);
      },
      moveRangeOnFirstSelection: false,
      ranges: selectionRange,
      showDateDisplay: false,
      className: styles.picker
    })]
  });
};
/* harmony default export */ var dateRangePicker = ((/* unused pure expression or super */ null && (dateRangePicker_DateRangeComponent)));
// EXTERNAL MODULE: ./node_modules/moment-timezone/index.js
var moment_timezone = __webpack_require__(80008);
;// CONCATENATED MODULE: ./_unisearch/common/form/timePeriod.js

var timePeriod_excluded = (/* unused pure expression or super */ null && (["name", "value", "handleTimePeriod"]));









var TimePeriod = function TimePeriod(_ref) {
  var _value$time;

  var _ref$name = _ref.name,
      name = _ref$name === void 0 ? "timePriod" : _ref$name,
      value = _ref.value,
      handleTimePeriod = _ref.handleTimePeriod,
      props = _objectWithoutProperties(_ref, timePeriod_excluded);

  var _useState = useState("All time periods"),
      timeState = _useState[0],
      setTimeState = _useState[1];

  var _useState2 = useState(null),
      anchorElTime = _useState2[0],
      setAnchorElTime = _useState2[1];

  var openTime = Boolean(anchorElTime);
  var todayRange = "".concat(moment().format("YYYY/MM/DD"), " - ").concat(moment().format("YYYY/MM/DD")); //Handle Date Selection

  var handleDateSelect = function handleDateSelect(name, data) {
    if (handleTimePeriod) {
      handleTimePeriod({
        period: "custom",
        time: data
      });
    }
  };

  var selectTimePriod = function selectTimePriod(item) {
    setTimeState(item.title);
    var today = moment().format("YYYY/MM/DD");
    var yesterday = moment().add(-1, "days").format("YYYY/MM/DD");
    var sevenDays = moment().add(-7, "days").format("YYYY/MM/DD");
    var thirtyDays = moment().add(-30, "days").format("YYYY/MM/DD");
    var lastsevendays = "".concat(sevenDays, " - ").concat(today);
    var lastthirtydays = "".concat(thirtyDays, " - ").concat(today);

    if (handleTimePeriod) {
      if (item.value == "today") {
        handleTimePeriod({
          period: item.value,
          time: "".concat(today, " - ").concat(today)
        });
      } else if (item.value == "yesterday") {
        handleTimePeriod({
          period: item.value,
          time: "".concat(today, " - ").concat(yesterday)
        });
      } else if (item.value == "lastsevendays") {
        handleTimePeriod({
          period: item.value,
          time: lastsevendays
        });
      } else if (item.value == "lastthirtydays") {
        handleTimePeriod({
          period: item.value,
          time: lastthirtydays
        });
      } else if (item.value == "custom") {
        handleTimePeriod({
          period: item.value,
          time: "".concat(today, " - ").concat(today)
        });
      } else {
        handleTimePeriod({
          period: item.value,
          time: ""
        });
      }
    } //close popup


    setAnchorElTime(null);
  };

  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.filter_dropdown_title,
      onClick: function onClick(e) {
        return setAnchorElTime(e.currentTarget);
      },
      children: [/*#__PURE__*/_jsx("span", {
        children: timeState
      }), /*#__PURE__*/_jsx(MdArrowDropDown, {
        className: styles.dropdown_icon
      })]
    }), /*#__PURE__*/_jsx(Menu, {
      anchorEl: anchorElTime,
      open: openTime,
      onClose: function onClose() {
        return setAnchorElTime(null);
      },
      classes: {
        paper: styles.activity_dropdown
      },
      anchorOrigin: {
        horizontal: "left",
        vertical: "bottom"
      },
      children: /*#__PURE__*/_jsx("li", {
        children: /*#__PURE__*/_jsx("ul", {
          className: styles.time_dropdown_lists,
          children: timePeriods().map(function (item, i) {
            return /*#__PURE__*/_jsxs("li", {
              className: styles.time_dropdown_list,
              onClick: function onClick() {
                selectTimePriod(item);
              },
              children: [/*#__PURE__*/_jsx("span", {
                className: styles.time_dropdown_first,
                children: item.title
              }), /*#__PURE__*/_jsx("span", {
                className: styles.time_dropdown_last,
                children: item.time
              })]
            }, "".concat(i + "timeData"));
          })
        })
      })
    }), timeState == "Custom Period" && /*#__PURE__*/_jsx(DateRangeComponent, {
      name: "time",
      value: (_value$time = value === null || value === void 0 ? void 0 : value.time) !== null && _value$time !== void 0 ? _value$time : todayRange,
      setFieldValue: handleDateSelect
    })]
  });
};
/* harmony default export */ var timePeriod = ((/* unused pure expression or super */ null && (TimePeriod)));
;// CONCATENATED MODULE: ./_unisearch/common/form/index.js












/***/ }),

/***/ 53469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CourseLoadingScreen */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84849);
/* harmony import */ var react_loading_skeleton_dist_skeleton_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36860);
/* harmony import */ var react_loading_skeleton_dist_skeleton_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_loading_skeleton_dist_skeleton_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _course_screen_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10396);
/* harmony import */ var _course_screen_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_course_screen_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var CourseLoadingScreen = function CourseLoadingScreen() {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
    className: (_course_screen_module_scss__WEBPACK_IMPORTED_MODULE_3___default().wrapper),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
      className: (_course_screen_module_scss__WEBPACK_IMPORTED_MODULE_3___default().headingWrapper),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
        className: (_course_screen_module_scss__WEBPACK_IMPORTED_MODULE_3___default().headingLeft),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          className: (_course_screen_module_scss__WEBPACK_IMPORTED_MODULE_3___default().image_wrapper),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            height: 80,
            width: 150
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            height: 30,
            width: "100%",
            className: (_course_screen_module_scss__WEBPACK_IMPORTED_MODULE_3___default().heading)
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            count: 3,
            height: 15,
            width: "100%"
          })]
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            height: 15,
            width: 50,
            style: {
              "float": "right"
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            height: 15,
            width: 50,
            style: {
              "float": "right"
            }
          })]
        })
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      height: 30,
      width: "100%",
      className: (_course_screen_module_scss__WEBPACK_IMPORTED_MODULE_3___default().table_heading)
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
      count: 4,
      height: 15,
      width: "100%"
    })]
  });
};
/* harmony default export */ __webpack_exports__["Z"] = (CourseLoadingScreen);

/***/ }),

/***/ 12083:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h1": function() { return /* reexport */ VideoStream; }
});

// UNUSED EXPORTS: MediaList, MediaUPload

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./_unisearch/helpers/index.js + 6 modules
var helpers = __webpack_require__(72145);
// EXTERNAL MODULE: ./_unisearch/helpers/api/index.js
var api = __webpack_require__(85014);
// EXTERNAL MODULE: ./_unisearch/helpers/tableHelpers.js
var tableHelpers = __webpack_require__(11112);
// EXTERNAL MODULE: ./_unisearch/helpers/utils.js
var utils = __webpack_require__(90705);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./_unisearch/common/media/mediaForm.jsx



/* eslint-disable react-hooks/exhaustive-deps */









var initialData = {
  mediaName: "",
  alt: "",
  src: ""
};
var mediaForm_MediaForm = function MediaForm(_ref) {
  var drawerHandler = _ref.drawerHandler,
      mediaManagerId = _ref.mediaManagerId;

  var _useState = useState(false),
      loading = _useState[0],
      setLoading = _useState[1];

  var _useState2 = useState(initialData),
      singleItem = _useState2[0],
      setSingleItem = _useState2[1]; // Validation schema


  var validationSchema = Yup.object().shape({
    mediaName: Yup.string().required("Field is required"),
    alt: Yup.string().required("Field is required")
  }); //get single item data for edit

  var getSingleData = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return API.get("/media-manager/".concat(mediaManagerId)).then(function (res) {
                if (!res.error) {
                  setSingleItem(res.data);
                }
              })["catch"](function (error) {
                swalError(error);
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getSingleData() {
      return _ref2.apply(this, arguments);
    };
  }(); //get single data


  useEffect(function () {
    if (mediaManagerId) {
      getSingleData();
    }
  }, [mediaManagerId]); //store signle data

  var storeData = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(values, action) {
      var formData;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              formData = new FormData();
              formData.append("mediaName", values.mediaName);
              formData.append("alt", values.alt);
              formData.append("tag", values.tag);

              if (!mediaManagerId) {
                _context2.next = 7;
                break;
              }

              _context2.next = 7;
              return API.patch("/media-manager/".concat(mediaManagerId), formData).then(function (res) {
                if (!res.error) {
                  swalSuccess(res.message);
                  drawerHandler();
                } else {
                  swalError("Upload Failed");
                }
              })["catch"](function (error) {
                swalError(error);
              });

            case 7:
              action.resetForm();

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function storeData(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_jsx(Formik, {
    initialValues: singleItem,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: function onSubmit(values, action) {
      storeData(values, action);
    },
    children: function children(_ref4) {
      var _values$mediaName, _values$alt;

      var handleSubmit = _ref4.handleSubmit,
          setFieldValue = _ref4.setFieldValue,
          values = _ref4.values,
          errors = _ref4.errors,
          touched = _ref4.touched;
      return /*#__PURE__*/_jsx(Form, {
        className: "form",
        children: /*#__PURE__*/_jsxs("div", {
          className: "admin_drawer_container",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "admin_drawer_head",
            children: [/*#__PURE__*/_jsx("div", {
              className: "admin_drawer_head_left",
              children: /*#__PURE__*/_jsx("h3", {
                className: "admin_drawer_head_title",
                children: "Edit Media Item"
              })
            }), /*#__PURE__*/_jsx("button", {
              type: "button",
              className: "admin_drawer_head_right",
              onClick: function onClick() {
                drawerHandler();
                setSingleItem(initialData);
              },
              children: /*#__PURE__*/_jsx(FiX, {})
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: "admin_drawer_body_outer",
            children: /*#__PURE__*/_jsx("div", {
              className: "admin_drawer_body",
              children: /*#__PURE__*/_jsxs("div", {
                className: "mediaFlex",
                children: [/*#__PURE__*/_jsx("div", {
                  className: "mediaFile",
                  children: FileColumnFormater(values.src)
                }), /*#__PURE__*/_jsxs("div", {
                  className: "mediaForm",
                  children: [/*#__PURE__*/_jsxs("div", {
                    className: "admin_form_group",
                    children: [/*#__PURE__*/_jsxs("label", {
                      htmlFor: "course",
                      className: "admin_label",
                      children: ["File Name ", /*#__PURE__*/_jsx("span", {
                        className: "asterisk",
                        children: "*"
                      })]
                    }), /*#__PURE__*/_jsx("input", {
                      type: "text",
                      className: "admin_input",
                      placeholder: "name here...",
                      onWheel: function onWheel(event) {
                        return event.currentTarget.blur();
                      },
                      onChange: function onChange(e) {
                        setFieldValue("mediaName", e.target.value);
                      },
                      value: (_values$mediaName = values.mediaName) !== null && _values$mediaName !== void 0 ? _values$mediaName : ""
                    }), errors.mediaName && touched.mediaName && /*#__PURE__*/_jsx("div", {
                      className: "invalid-feedback",
                      children: errors.mediaName
                    })]
                  }), /*#__PURE__*/_jsxs("div", {
                    className: "admin_form_group",
                    children: [/*#__PURE__*/_jsxs("label", {
                      htmlFor: "course",
                      className: "admin_label",
                      children: ["ALT Text ", /*#__PURE__*/_jsx("span", {
                        className: "asterisk",
                        children: "*"
                      })]
                    }), /*#__PURE__*/_jsx("input", {
                      type: "text",
                      className: "admin_input",
                      placeholder: "name here...",
                      onWheel: function onWheel(event) {
                        return event.currentTarget.blur();
                      },
                      onChange: function onChange(e) {
                        setFieldValue("alt", e.target.value);
                      },
                      value: (_values$alt = values.alt) !== null && _values$alt !== void 0 ? _values$alt : ""
                    }), errors.alt && touched.alt && /*#__PURE__*/_jsx("div", {
                      className: "invalid-feedback",
                      children: errors.alt
                    })]
                  })]
                })]
              })
            })
          }), /*#__PURE__*/_jsxs("div", {
            className: "admin_drawer_footer",
            children: [/*#__PURE__*/_jsx("div", {
              className: "admin_drawer_footer_left",
              children: /*#__PURE__*/_jsx("button", {
                type: "button",
                className: "admin btn btn-cancel",
                onClick: function onClick() {
                  drawerHandler();
                  setSingleItem(initialData);
                },
                children: "Cancel"
              })
            }), /*#__PURE__*/_jsx("div", {
              className: "admin_drawer_footer_right",
              children: /*#__PURE__*/_jsx("button", {
                type: "button",
                className: "admin btn btn-primary",
                onClick: function onClick() {
                  handleSubmit();
                },
                children: "Update"
              })
            })]
          })]
        })
      });
    }
  });
};
/* harmony default export */ var mediaForm = ((/* unused pure expression or super */ null && (mediaForm_MediaForm)));
;// CONCATENATED MODULE: ./_unisearch/common/media/media_list.jsx



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



/* eslint-disable @next/next/no-img-element */

/* eslint-disable react-hooks/exhaustive-deps */















var MediaList = function MediaList(props) {
  var _paginationInfo$curre, _paginationInfo$limit, _statusOverview$activ, _statusOverview$trash, _serachFilter$filter4, _paginationInfo$total, _serachFilter$filter5;

  var router = useRouter(); //Drawer State management

  var _useState = useState(false),
      drawerState = _useState[0],
      setDrawerState = _useState[1];

  var toggleDrawer = function toggleDrawer(open) {
    return function (event) {
      if (event && event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
        return;
      }

      setDrawerState(open);
    };
  }; //media types


  var meditTypes = [{
    label: "Select",
    value: ""
  }, {
    label: "Image",
    value: "image"
  }, {
    label: "PDF",
    value: "pdf"
  }, {
    label: "Video",
    value: "video"
  }]; //sidebar

  var _useState2 = useState(false),
      showSidebar = _useState2[0],
      setShowSidebar = _useState2[1];

  var toggleSidebar = function toggleSidebar() {
    setShowSidebar(function (prev) {
      return !prev;
    });
  }; //Pagination information


  var _useState3 = useState({
    currentPage: 1,
    limit: 20
  }),
      paginationInfo = _useState3[0],
      setPaginationInfo = _useState3[1]; //all data


  var _useState4 = useState([]),
      entities = _useState4[0],
      setEntities = _useState4[1];

  var _useState5 = useState({}),
      statusOverview = _useState5[0],
      setStatusOverview = _useState5[1];

  var _useState6 = useState([]),
      selectedIds = _useState6[0],
      setSelectedIds = _useState6[1];

  var _useState7 = useState(false),
      mediaId = _useState7[0],
      setMediaId = _useState7[1];

  var _useState8 = useState(false),
      listLoading = _useState8[0],
      setListLoading = _useState8[1]; //initiet state


  var _useState9 = useState({
    filter: {
      status: "Active",
      mediaName: "",
      tag: ""
    },
    sortOrder: "DESC",
    sortField: "mediaManagerId",
    pageNumber: (_paginationInfo$curre = paginationInfo.currentPage) !== null && _paginationInfo$curre !== void 0 ? _paginationInfo$curre : 1,
    pageSize: (_paginationInfo$limit = paginationInfo.limit) !== null && _paginationInfo$limit !== void 0 ? _paginationInfo$limit : 20
  }),
      serachFilter = _useState9[0],
      setSearchFilterState = _useState9[1]; //get pate with filter


  var getAllData = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var filter,
          _args = arguments;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              filter = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
              setListLoading(true);
              _context.next = 4;
              return API.post("/media-manager/find-mediaFile", filter ? filter : serachFilter).then(function (res) {
                if (res.statusCode == 201 && !res.error) {
                  var _res$data, _res$data2, _res$data3, _res$data4, _res$data5, _res$data6, _res$data7;

                  setEntities(res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.results);
                  setPaginationInfo({
                    currentPage: res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.currentPage,
                    limit: res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.limit,
                    nextPage: res === null || res === void 0 ? void 0 : (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.nextPage,
                    page_total: res === null || res === void 0 ? void 0 : (_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.page_total,
                    previousPage: res === null || res === void 0 ? void 0 : (_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : _res$data6.previousPage,
                    totalRows: res === null || res === void 0 ? void 0 : (_res$data7 = res.data) === null || _res$data7 === void 0 ? void 0 : _res$data7.total
                  });
                  setListLoading(false);
                } else {
                  swalError(res.message);
                }
              })["catch"](function (error) {
                swalError(error);
              });

            case 4:
              setListLoading(false);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function getAllData() {
      return _ref.apply(this, arguments);
    };
  }(); //get overview


  var getOverview = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return API.get("/media-manager/status-overview").then(function (res) {
                if (res.statusCode == 200 && !res.error) {
                  setStatusOverview(res.data);
                }
              })["catch"](function (error) {
                swalError(error);
              });

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function getOverview() {
      return _ref2.apply(this, arguments);
    };
  }(); //get overview


  useEffect(function () {
    getOverview();
  }, []); //effect when laod or change page

  useEffect(function () {
    getAllData();
  }, [serachFilter.pageNumber, serachFilter.pageSize, serachFilter.sortField, serachFilter.sortOrder, serachFilter.filter.status]);

  var getActiveLink = function getActiveLink() {
    var _serachFilter$filter, _serachFilter$filter2, _serachFilter$filter3;

    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (serachFilter !== null && serachFilter !== void 0 && (_serachFilter$filter = serachFilter.filter) !== null && _serachFilter$filter !== void 0 && _serachFilter$filter.status && (serachFilter === null || serachFilter === void 0 ? void 0 : (_serachFilter$filter2 = serachFilter.filter) === null || _serachFilter$filter2 === void 0 ? void 0 : _serachFilter$filter2.status) == value) {
      return "active";
    } else if (value == "all" && !(serachFilter !== null && serachFilter !== void 0 && (_serachFilter$filter3 = serachFilter.filter) !== null && _serachFilter$filter3 !== void 0 && _serachFilter$filter3.status)) {
      return "active";
    }
  }; //when change keywords


  var handleKeyword = function handleKeyword(e) {
    setSearchFilterState(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, {
        filter: _objectSpread(_objectSpread({}, serachFilter.filter), {}, {
          mediaName: e.target.value
        }),
        pageNumber: 1
      });
    });
  }; //when press enter


  var handleKeyUp = function handleKeyUp(event) {
    if (event.key === "Enter") {
      getAllData();
    } else {
      setTimeout(function () {
        getAllData();
      }, 1000);
    }
  }; //handle status


  var handleFilterStatus = function handleFilterStatus() {
    var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Active";

    var newFilter = _objectSpread(_objectSpread({}, serachFilter), {}, {
      filter: {}
    });

    if (status != "all") {
      newFilter.filter.status = status;
    }

    setSearchFilterState(newFilter);
  }; //paginationHandler


  var handleTableChange = function handleTableChange(type, tableprops) {
    if (type == "pagination") {
      setSearchFilterState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          pageNumber: tableprops.page,
          pageSize: tableprops.sizePerPage
        });
      });
    }

    if (type == "sort") {
      setSearchFilterState(function (prev) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          sortOrder: tableprops.sortOrder.toUpperCase(),
          sortField: tableprops.sortField
        });
      });
    }
  }; //handleRestore


  var handleRestore = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(row) {
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return API.patch("/media-manager/change-status", {
                ids: [parseInt(row.mediaManagerId)],
                status: "Active"
              }).then(function (res) {
                if (!res.error) {
                  swalSuccess("Item Restore Successfully");
                  getOverview();
                  getAllData();
                } else {
                  swalError(res.message);
                }
              });

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleRestore(_x) {
      return _ref3.apply(this, arguments);
    };
  }(); //handleDelete


  var handleDelete = function handleDelete(row) {
    if (row.status == "Deleted") {
      handleHardDelete([parseInt(row.mediaManagerId)]);
    } else {
      handleSoftDelete([parseInt(row.mediaManagerId)]);
    }
  };

  var handleSoftDelete = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(ids) {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              swalConfirm("to Trash this item", "Are you sure").then( /*#__PURE__*/function () {
                var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(cnf) {
                  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          if (!cnf.isConfirmed) {
                            _context4.next = 3;
                            break;
                          }

                          _context4.next = 3;
                          return API.patch("/media-manager/change-status", {
                            ids: ids,
                            status: "Deleted"
                          }).then(function (res) {
                            if (!res.error) {
                              swalSuccess("Item Deleted Successfully");
                              getOverview();
                              getAllData();
                            } else {
                              swalError(res.message);
                            }
                          });

                        case 3:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                }));

                return function (_x3) {
                  return _ref5.apply(this, arguments);
                };
              }());

            case 1:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function handleSoftDelete(_x2) {
      return _ref4.apply(this, arguments);
    };
  }(); //handleDelete


  var handleHardDelete = function handleHardDelete(ids) {
    swalConfirm("to delete", "Are you sure").then( /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(cnf) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!cnf.isConfirmed) {
                  _context6.next = 3;
                  break;
                }

                _context6.next = 3;
                return API.patch("/media-manager/hard-delete", {
                  ids: ids
                }).then(function (res) {
                  if (!res.error) {
                    swalSuccess("Item Deleted Successfully");
                    getOverview();
                    getAllData();
                  } else {
                    swalError(res.message);
                  }
                });

              case 3:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x4) {
        return _ref6.apply(this, arguments);
      };
    }());
  }; //handleEdit


  var handleEdit = function handleEdit(row) {
    setDrawerState(true);
    setMediaId(row.mediaManagerId);
  };

  var viewMediaAction = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(row) {
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    return function viewMediaAction(_x5) {
      return _ref7.apply(this, arguments);
    };
  }(); //reset fitlered


  var handleReset = function handleReset(e) {
    var newSf = _objectSpread(_objectSpread({}, serachFilter), {}, {
      filter: {
        status: "Active"
      },
      pageNumber: 1
    }); //reset state


    setSearchFilterState(newSf); //get data

    getAllData(newSf);
  };

  var drawerHandler = function drawerHandler() {
    setDrawerState(false);
    setMediaId(false);
    getAllData();
  };

  var columns = [{
    dataField: "src",
    text: "Media File",
    formatter: FileColumnFormater,
    style: {
      width: "130px"
    }
  }, {
    dataField: "mediaName",
    text: "Name",
    sort: true
  }, {
    dataField: "fileType",
    text: "File Type",
    sort: true,
    style: {
      width: "100px"
    }
  }, {
    dataField: "fileSize",
    text: "File Size",
    style: {
      width: "100px"
    }
  }, {
    dataField: "alt",
    text: "ALT Text",
    style: {
      width: "300px"
    }
  }, {
    dataField: "status",
    formatter: StatusColumnFormatter,
    text: "Status",
    style: {
      width: "100px"
    }
  }, {
    dataField: "",
    text: "Actions",
    formatter: ActionsColumnFormatter,
    formatExtraData: {
      editAction: handleEdit,
      viewMediaAction: viewMediaAction,
      deleteAction: handleDelete,
      restoreAction: handleRestore
    },
    classes: "text-right pr-0",
    headerClasses: "text-right pr-3",
    style: {
      width: "100px"
    }
  }];
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsxs("div", {
      className: "action_header",
      children: [/*#__PURE__*/_jsx("div", {
        className: "action_header_left",
        children: /*#__PURE__*/_jsxs("ul", {
          className: "action_header_left_list",
          children: [/*#__PURE__*/_jsx("li", {
            onClick: function onClick() {
              handleFilterStatus("all");
            },
            className: getActiveLink("all"),
            children: "All"
          }), /*#__PURE__*/_jsxs("li", {
            onClick: function onClick() {
              handleFilterStatus("Active");
            },
            className: getActiveLink("Active"),
            children: ["Published (", (_statusOverview$activ = statusOverview === null || statusOverview === void 0 ? void 0 : statusOverview.active) !== null && _statusOverview$activ !== void 0 ? _statusOverview$activ : "0", ")"]
          }), /*#__PURE__*/_jsxs("li", {
            onClick: function onClick() {
              handleFilterStatus("Deleted");
            },
            className: getActiveLink("Deleted"),
            children: ["Trash (", (_statusOverview$trash = statusOverview === null || statusOverview === void 0 ? void 0 : statusOverview.trash) !== null && _statusOverview$trash !== void 0 ? _statusOverview$trash : "0", ")"]
          }), selectedIds && selectedIds.length > 0 && /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsxs("button", {
              onClick: function onClick() {
                if (serachFilter.filter.status == "Deleted") {
                  handleHardDelete(selectedIds.map(Number));
                } else {
                  handleSoftDelete(selectedIds.map(Number));
                }
              },
              className: "action_delete",
              children: [/*#__PURE__*/_jsx(IoMdTrash, {
                className: "action_delete_icon"
              }), "Delete"]
            })
          }), /*#__PURE__*/_jsx("li", {
            children: /*#__PURE__*/_jsxs("div", {
              className: "action_search",
              children: [listLoading ? /*#__PURE__*/_jsx(CircularProgress, {
                size: 10,
                className: "action_loading"
              }) : /*#__PURE__*/_jsx(FiSearch, {
                className: "action_search_icon"
              }), /*#__PURE__*/_jsx(FiSearch, {
                className: "action_search_icon"
              }), /*#__PURE__*/_jsx("input", {
                type: "text",
                placeholder: "Search Here",
                name: "mediaName",
                value: serachFilter === null || serachFilter === void 0 ? void 0 : (_serachFilter$filter4 = serachFilter.filter) === null || _serachFilter$filter4 === void 0 ? void 0 : _serachFilter$filter4.mediaName,
                onChange: handleKeyword,
                onKeyUp: handleKeyUp
              })]
            })
          })]
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "action_header_right",
        children: [/*#__PURE__*/_jsx(Link, {
          legacyBehavior: true,
          href: "/app/university/media/new",
          children: /*#__PURE__*/_jsx("a", {
            className: "admin btn btn-primary",
            children: "Add New"
          })
        }), /*#__PURE__*/_jsx(TopPaginationHandler, {
          paginationInfo: paginationInfo,
          paginationHandler: handleTableChange
        }), /*#__PURE__*/_jsx("button", {
          className: "sidebar_toggle",
          onClick: toggleSidebar,
          children: /*#__PURE__*/_jsx(MdVerticalSplit, {})
        })]
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "admin_page_wrapper",
      children: /*#__PURE__*/_jsx("div", {
        className: "admin_table_wrapper ".concat(showSidebar ? "sidebar_present" : ""),
        children: entities && (entities === null || entities === void 0 ? void 0 : entities.length) == 0 ? /*#__PURE__*/_jsx("div", {
          className: "no_record_found",
          children: "No record found"
        }) : /*#__PURE__*/_jsx(UniTableComponent, {
          data: entities !== null && entities !== void 0 ? entities : [],
          columns: columns,
          keyField: "mediaManagerId",
          page: paginationInfo.currentPage,
          sizePerPage: paginationInfo.limit,
          totalSize: (_paginationInfo$total = paginationInfo.totalRows) !== null && _paginationInfo$total !== void 0 ? _paginationInfo$total : 0,
          onTableChange: handleTableChange,
          selectRow: RowSelection(selectedIds, setSelectedIds, "mediaManagerId")
        })
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: "filter_sidebar ".concat(showSidebar ? "filter_sidebar_open" : ""),
      children: [/*#__PURE__*/_jsx("div", {
        className: "filter_sidebar_header",
        children: /*#__PURE__*/_jsx("div", {
          className: "filter_sidebar_title",
          children: "FILTERS"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "filter_sidebar_body",
        children: /*#__PURE__*/_jsxs("div", {
          className: "admin_form_group",
          children: [/*#__PURE__*/_jsx("label", {
            htmlFor: "role",
            className: "admin_label",
            children: "Media Types"
          }), /*#__PURE__*/_jsx(Select, {
            menuPortalTarget: typeof document !== "undefined" ? document.body : "",
            id: "types",
            name: "roleId",
            instanceId: "roleId",
            placeholder: "Select One",
            styles: reactSelectStyleAdmin,
            options: meditTypes !== null && meditTypes !== void 0 ? meditTypes : [],
            value: serachFilter !== null && serachFilter !== void 0 && (_serachFilter$filter5 = serachFilter.filter) !== null && _serachFilter$filter5 !== void 0 && _serachFilter$filter5.tag && meditTypes ? meditTypes.filter(function (item) {
              var _serachFilter$filter6;

              return item.value === (serachFilter === null || serachFilter === void 0 ? void 0 : (_serachFilter$filter6 = serachFilter.filter) === null || _serachFilter$filter6 === void 0 ? void 0 : _serachFilter$filter6.tag);
            }) : "",
            onChange: function onChange(item) {
              setSearchFilterState(function (prev) {
                return _objectSpread(_objectSpread({}, prev), {}, {
                  filter: _objectSpread(_objectSpread({}, serachFilter.filter), {}, {
                    tag: item.value
                  })
                });
              });
            }
          })]
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "filter_sidebar_footer ",
        children: [/*#__PURE__*/_jsxs("button", {
          className: "admin btn btn-admin-outline",
          onClick: handleReset,
          children: [listLoading ? /*#__PURE__*/_jsx(CircularProgress, {
            size: 15,
            style: {
              color: "grey"
            }
          }) : "", "Reset"]
        }), /*#__PURE__*/_jsxs("button", {
          className: "admin btn btn-primary",
          onClick: function onClick() {
            getAllData();
          },
          children: [listLoading ? /*#__PURE__*/_jsx(CircularProgress, {
            size: 15,
            style: {
              color: "white"
            }
          }) : "", "Apply"]
        })]
      })]
    }), mediaId && /*#__PURE__*/_jsx(SwipeableDrawer, {
      anchor: "right",
      open: drawerState,
      onClose: toggleDrawer(true),
      onOpen: toggleDrawer(true),
      classes: {
        paper: "admin_drawer"
      },
      children: /*#__PURE__*/_jsx(MediaForm, {
        drawerHandler: drawerHandler,
        mediaManagerId: mediaId
      })
    })]
  });
};
/* harmony default export */ var media_list = ((/* unused pure expression or super */ null && (MediaList)));
;// CONCATENATED MODULE: ./_unisearch/common/media/new.jsx



var _excluded = (/* unused pure expression or super */ null && (["onUploaded", "showTitle", "allowItem"]));


/* eslint-disable @next/next/no-img-element */

/* eslint-disable react-hooks/exhaustive-deps */












var MediaUPload = function MediaUPload(_ref) {
  var onUploaded = _ref.onUploaded,
      _ref$showTitle = _ref.showTitle,
      showTitle = _ref$showTitle === void 0 ? true : _ref$showTitle,
      _ref$allowItem = _ref.allowItem,
      allowItem = _ref$allowItem === void 0 ? "all" : _ref$allowItem,
      props = _objectWithoutProperties(_ref, _excluded);

  var btnRef = useRef();
  var formates = ["image/jpg", "image/jpeg", "image/png", "image/webp", "application/pdf", "application/xls", "application/xlsx", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/docx"];

  var _useState = useState(),
      allowFormate = _useState[0],
      setAllowFormate = _useState[1];

  var allowed_size = 1000000;

  var _useState2 = useState(false),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState([]),
      names = _useState3[0],
      setNames = _useState3[1];

  var _useState4 = useState([]),
      altName = _useState4[0],
      setAltName = _useState4[1];

  var _useState5 = useState([]),
      tags = _useState5[0],
      setTags = _useState5[1];

  var _useState6 = useState([]),
      fileState = _useState6[0],
      setFileState = _useState6[1];

  var changeName = function changeName(e) {
    var index = e.target.name.replace("file_name_", "");

    var namesArr = _toConsumableArray(names);

    namesArr[index] = e.target.value;
    setNames(namesArr);
  };

  var changeAlt = function changeAlt(e) {
    var index = e.target.name.replace("alt_name_", "");

    var altNameArr = _toConsumableArray(altName);

    altNameArr[index] = e.target.value;
    setAltName(altNameArr);
  }; //remove item which upload


  var removeCurrent = function removeCurrent(index) {
    var fileArr = _toConsumableArray(fileState);

    var namesArr = _toConsumableArray(names);

    var tagsArr = _toConsumableArray(tags);

    var altNameArr = _toConsumableArray(altName);

    if (index !== -1) {
      fileArr.splice(index, 1);
      namesArr.splice(index, 1);
      tagsArr.splice(index, 1);
      altNameArr.splice(index, 1);
      setFileState(fileArr);
      setNames(namesArr);
      setAltName(altNameArr);
      setTags(tagsArr);
    }
  };

  var handleRemove = function handleRemove(index) {
    swalConfirm("to remove this").then(function (result) {
      if (result.isConfirmed) {
        removeCurrent(index);
      }
    })["catch"](function (error) {
      console.log(error);
    });
  };

  var onFileChange = function onFileChange(event) {
    var namesArr = _toConsumableArray(names);

    var tagsArr = _toConsumableArray(tags);

    var fileArr = _toConsumableArray(fileState);

    var files = event.target.files;

    if (files && files.length > 0) {
      for (var i = 0; i < files.length; i++) {
        if (allowFormate.includes(files[i].type) && files[i].size / 1000 <= allowed_size) {
          var fname = files[i].name;
          var name = fname.split(".").slice(0, -1).join(".");
          namesArr.push(name); // let tagName = files[i].type.split("/")[0];

          var tagName = filterFileType(files[i].type);
          tagsArr.push(tagName);
          fileArr.push(files[i]);
        } else {
          swalError("Upload file ( " + files[i].name + " ) is not allowed");
        }
      }

      setFileState(fileArr);
      setNames(namesArr);
      setAltName(namesArr);
      setTags(tagsArr);
      document.getElementById("image").value = "";
    }
  };

  var createTable = function createTable() {
    var table = [];

    if (fileState && fileState.length > 0) {
      var _loop = function _loop(i) {
        if (allowFormate.indexOf(fileState[i].type) > -1) {
          table.push( /*#__PURE__*/_jsxs(TableRow, {
            children: [/*#__PURE__*/_jsx(TableCell, {
              children: i + 1
            }), /*#__PURE__*/_jsx(TableCell, {
              children: /*#__PURE__*/_jsx("input", {
                name: "file_name_".concat(i),
                onChange: changeName,
                value: names[i],
                className: styles.fileName
              }, i)
            }), /*#__PURE__*/_jsx(TableCell, {
              children: /*#__PURE__*/_jsx("input", {
                name: "alt_name_".concat(i),
                onChange: changeAlt,
                value: altName[i],
                className: styles.fileName
              }, i)
            }), /*#__PURE__*/_jsx(TableCell, {
              children: /*#__PURE__*/_jsx("span", {
                className: styles.shorter,
                children: filterFileType(fileState[i].type)
              })
            }), /*#__PURE__*/_jsx(TableCell, {
              children: /*#__PURE__*/_jsx(IconButton, {
                color: "warning",
                onClick: function onClick() {
                  return handleRemove(i);
                },
                value: i,
                children: /*#__PURE__*/_jsx(RiDeleteBin6Line, {})
              })
            })]
          }, i));
        } else {
          //remove state
          removeCurrent(i); //show alert

          swalError(fileState[i].type + " Not Allowed");
        }
      };

      for (var i = 0; i < fileState.length; i++) {
        _loop(i);
      }
    }

    return table;
  }; //upload file


  var saveFile = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(values) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              swalConfirm("To submit this file?", "Are you sure", "Yes upload it").then( /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(res) {
                  var formData;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          if (!res.isConfirmed) {
                            _context.next = 10;
                            break;
                          }

                          setLoading(true);
                          formData = new FormData();
                          formData.append("mediaName", names.toString());
                          formData.append("alt", altName.toString());
                          formData.append("tag", tags.toString());

                          if (fileState.length > 0) {
                            fileState.map(function (file, index) {
                              formData.append("files", file);
                            });
                          }

                          _context.next = 9;
                          return API.post("/media-manager", formData).then(function (res) {
                            if (!res.error) {
                              swalSuccess(res.message);
                              setTimeout(function () {
                                if (onUploaded) onUploaded(true);
                              }, 100);
                            } else {
                              swalError("Upload Failed");
                            }
                          })["catch"](function (error) {
                            swalError(error);
                          });

                        case 9:
                          setLoading(false);

                        case 10:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function (_x2) {
                  return _ref3.apply(this, arguments);
                };
              }());

            case 1:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function saveFile(_x) {
      return _ref2.apply(this, arguments);
    };
  }(); //set Allow formates


  useEffect(function () {
    if (allowItem == "all") {
      setAllowFormate(formates);
    } else if (allowItem == "image") {
      setAllowFormate(["image/jpg", "image/jpeg", "image/png", "image/webp"]);
    } else if (allowItem == "pdf") {
      setAllowFormate(["application/pdf"]);
    } else if (allowItem == "docx" || allowItem == "doc" || allowItem == "xlsx" || allowItem == "xls") {
      setAllowFormate(["application/xls", "application/xlsx", "application/vnd.ms-excel", "application/vnd.openxmlformats-officedocument.wordprocessingml.document", "application/docx"]);
    }
  }, [allowItem]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.wrapper,
    children: [showTitle && /*#__PURE__*/_jsx("div", {
      className: styles.heading,
      children: /*#__PURE__*/_jsx("h2", {
        children: "Media Upload"
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles.content,
      children: /*#__PURE__*/_jsxs(Grid, {
        container: true,
        spacing: 4,
        children: [/*#__PURE__*/_jsx(Grid, {
          item: true,
          md: 3,
          sm: 12,
          children: /*#__PURE__*/_jsxs("div", {
            className: styles.form_group,
            children: [/*#__PURE__*/_jsxs("label", {
              htmlFor: "image",
              children: [/*#__PURE__*/_jsx("input", {
                id: "image",
                type: "file",
                name: "files",
                multiple: true,
                onChange: function onChange(e) {
                  return onFileChange(e);
                },
                style: {
                  display: "none"
                },
                disabled: loading
              }), /*#__PURE__*/_jsxs("div", {
                className: styles.media_upload_wrapper,
                children: [/*#__PURE__*/_jsx("div", {
                  className: styles.image_wrapper,
                  children: /*#__PURE__*/_jsx("img", {
                    src: getAssets("assets/images/vector-image.png"),
                    alt: "Vector"
                  })
                }), /*#__PURE__*/_jsxs("div", {
                  className: styles.text1,
                  children: ["Drop your Image here, or ", /*#__PURE__*/_jsx("span", {
                    children: "browse"
                  }), " on your computer"]
                }), /*#__PURE__*/_jsx("div", {
                  className: styles.text2,
                  children: "Support: jpg, jpeg, png, pdf"
                })]
              })]
            }), fileState && fileState.length > 0 ? /*#__PURE__*/_jsxs("button", {
              ref: btnRef,
              type: "submit",
              className: "btn btn-warning ".concat(styles.action_btn),
              onClick: function onClick() {
                return saveFile();
              },
              disabled: loading,
              children: [loading && /*#__PURE__*/_jsx(CircularProgress, {
                size: 20
              }), /*#__PURE__*/_jsx("span", {
                className: "apsis-loader",
                children: "Upload Files"
              })]
            }) : /*#__PURE__*/_jsx(_Fragment, {})]
          })
        }), /*#__PURE__*/_jsx(Grid, {
          item: true,
          md: 9,
          sm: 12,
          children: /*#__PURE__*/_jsx(TableContainer, {
            children: /*#__PURE__*/_jsxs(Table, {
              className: "table ".concat(styles.uploadTable),
              children: [/*#__PURE__*/_jsx(TableHead, {
                children: /*#__PURE__*/_jsxs(TableRow, {
                  children: [/*#__PURE__*/_jsx(TableCell, {
                    children: "SL"
                  }), /*#__PURE__*/_jsx(TableCell, {
                    children: "New Name"
                  }), /*#__PURE__*/_jsx(TableCell, {
                    children: "Alt Tag"
                  }), /*#__PURE__*/_jsx(TableCell, {
                    children: "Type"
                  }), /*#__PURE__*/_jsx(TableCell, {
                    children: "Action"
                  })]
                })
              }), /*#__PURE__*/_jsx(TableBody, {
                children: createTable()
              })]
            })
          })
        })]
      })
    })]
  });
};
/* harmony default export */ var media_new = ((/* unused pure expression or super */ null && (MediaUPload)));
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(17674);
;// CONCATENATED MODULE: ./_unisearch/common/media/video_stream.jsx







var VideoStream = function VideoStream(_ref) {
  var myInfo = _ref.myInfo,
      configs = _ref.configs,
      type = _ref.type;
  var conferenceContainerId = "conference-container-id";
  var domain = "unimeet-server-route.myunisearch.com";

  var _React$useState = react.useState({}),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      jitsi = _React$useState2[0],
      setJitsi = _React$useState2[1];

  var loadJitsiScript = function loadJitsiScript() {
    var resolveLoadJitsiScriptPromise = null;
    var loadJitsiScriptPromise = new Promise(function (resolve) {
      resolveLoadJitsiScriptPromise = resolve;
    });
    var script = document.createElement("script");
    script.src = "https://unimeet-server-route.myunisearch.com/external_api.js";
    script.async = true;

    script.onload = function () {
      return resolveLoadJitsiScriptPromise(true);
    };

    document.body.appendChild(script);
    return loadJitsiScriptPromise;
  };

  var changeMeetingStatusForCounsiller = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(type === "mentor")) {
                _context.next = 11;
                break;
              }

              if (!configs.moderator) {
                _context.next = 9;
                break;
              }

              _context.prev = 2;
              _context.next = 5;
              return api/* default.get */.Z.get("/core/reset-mentor-meeting-status/".concat(configs.room)).then(function (res) {})["catch"](function (error) {//console.log(error);
              });

            case 5:
              _context.next = 9;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](2);

            case 9:
              _context.next = 19;
              break;

            case 11:
              if (!configs.moderator) {
                _context.next = 19;
                break;
              }

              _context.prev = 12;
              _context.next = 15;
              return api/* default.get */.Z.get("/core/reset-meeting-status/".concat(configs.room)).then(function (res) {})["catch"](function (error) {//console.log(error);
              });

            case 15:
              _context.next = 19;
              break;

            case 17:
              _context.prev = 17;
              _context.t1 = _context["catch"](12);

            case 19:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 7], [12, 17]]);
    }));

    return function changeMeetingStatusForCounsiller() {
      return _ref2.apply(this, arguments);
    };
  }();

  var initialiseJitsi = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2() {
      var options, _jitsi;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (window.JitsiMeetExternalAPI) {
                _context2.next = 3;
                break;
              }

              _context2.next = 3;
              return loadJitsiScript();

            case 3:
              options = {
                roomName: configs.room,
                roomPassword: configs.room + "-01",
                width: "100%",
                height: 700,
                configOverwrite: {
                  disableDeepLinking: true,
                  prejoinPageEnabled: false,
                  disableThirdPartyRequests: false
                },
                interfaceConfigOverwrite: {
                  filmStripOnly: false
                },
                parentNode: document.getElementById(conferenceContainerId),
                userInfo: {
                  moderator: configs.moderator,
                  displayName: myInfo.name,
                  email: myInfo.email
                },
                moderator: configs.moderator //:false //configs.moderator

              };
              _jitsi = new window.JitsiMeetExternalAPI(domain, options); // _jitsi.executeCommand('subject', 'Instant Video Session');

              _jitsi.addEventListener("participantRoleChanged", function (event) {
                if (event.role === "moderator" && configs.moderator === true) {
                  _jitsi.executeCommand("password", options.roomPassword);
                }
              });

              _jitsi.addEventListener("passwordRequired", function () {
                _jitsi.executeCommand("password", options.roomPassword);
              });

              _jitsi.addEventListener("readyToClose", function () {
                // console.log('call hung up fron add Event Listener Event');
                changeMeetingStatusForCounsiller();
              });

              setJitsi(_jitsi);

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function initialiseJitsi() {
      return _ref3.apply(this, arguments);
    };
  }();

  react.useEffect(function () {
    initialiseJitsi();
    window.addEventListener("beforeunload", function (e) {
      var confirmationMessage = "o/"; //(e || window.event).returnValue = confirmationMessage; //Gecko + IE

      changeMeetingStatusForCounsiller(); //return confirmationMessage; //Webkit, Safari, Chrome
    });
    return function () {
      var _jitsi$dispose;

      return jitsi === null || jitsi === void 0 ? void 0 : (_jitsi$dispose = jitsi.dispose) === null || _jitsi$dispose === void 0 ? void 0 : _jitsi$dispose.call(jitsi);
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    id: conferenceContainerId,
    style: {
      height: 720,
      width: "100%"
    }
  });
};
/* harmony default export */ var video_stream = ((/* unused pure expression or super */ null && (VideoStream)));
;// CONCATENATED MODULE: ./_unisearch/common/media/index.js




/***/ }),

/***/ 65842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _show_paginate_text_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49037);
/* harmony import */ var _show_paginate_text_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_show_paginate_text_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);

var _excluded = ["paginate"];






var ShowPaginateText = function ShowPaginateText(_ref) {
  var paginate = _ref.paginate,
      props = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, _excluded);

  var showingfrom = paginate.total > 0 ? parseInt(parseInt(paginate.currentPage) - 1) * parseInt(paginate.limit) + 1 : 0;
  var showingTo = parseInt(paginate.limit) > parseInt(paginate.page_total) ? parseInt(paginate.total) : parseInt(paginate.currentPage) * parseInt(paginate.limit) <= parseInt(paginate.total) ? parseInt(paginate.currentPage) * parseInt(paginate.limit) : parseInt(paginate.total);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    children: paginate ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
      className: "".concat((_show_paginate_text_module_scss__WEBPACK_IMPORTED_MODULE_3___default().shwing_num)),
      children: ["Showing ", showingfrom, " to ", showingTo, " of ", parseInt(paginate.total), " ", props.name ? props.name : "entries"]
    }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {})
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (ShowPaginateText);

/***/ }),

/***/ 59076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PaginationComponent */
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65824);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_show_paginate_text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65842);
/* harmony import */ var _pagination_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82641);
/* harmony import */ var _pagination_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_pagination_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);

var _excluded = ["paginate", "paginationHandler"];







var PaginationComponent = function PaginationComponent(_ref) {
  var paginate = _ref.paginate,
      paginationHandler = _ref.paginationHandler,
      props = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  if (paginate) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
      className: (_pagination_module_scss__WEBPACK_IMPORTED_MODULE_4___default().pagination_wrapper),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_components_show_paginate_text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        paginate: paginate
      }), paginate && paginate.total > 0 && paginate.currentPage > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        className: "custom_pagination",
        count: Math.ceil(paginate.total / paginate.limit),
        page: parseInt(paginate.currentPage),
        shape: "rounded",
        onChange: paginationHandler
      })]
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (PaginationComponent);

/***/ }),

/***/ 11112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bf": function() { return /* binding */ TopPaginationHandler; }
/* harmony export */ });
/* unused harmony exports actionStatus, sortCaret, headerSortingClasses, FormatAlignment, FormateImage, StatusColumnFormatter, ActionsColumnFormatter, switcherActions, statusActions, RowSelection, customPagination, UniTableComponent, NameColumnFormatter, FileColumnFormater */
/* harmony import */ var _Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4730);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(24141);
/* harmony import */ var _unisearch_helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72145);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap_table_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99038);
/* harmony import */ var react_bootstrap_table2_paginator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(814);
/* harmony import */ var react_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98547);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);


var _excluded = ["paginationInfo", "paginationHandler", "customClasses"];

/* eslint-disable jsx-a11y/alt-text */

/* eslint-disable @next/next/no-img-element */










 //Status list




var actionStatus = {
  Draft: "Draft",
  Publish: "Published",
  Trash: "Trash",
  Deleted: "Trash",
  Active: "Published",
  Inactive: "Inactive"
}; //Sort Caret

var sortCaret = function sortCaret(order, column) {
  if (!order) return /*#__PURE__*/_jsx("span", {
    className: "svg-icon svg-icon-sm svg-icon-primary ml-1 svg-icon-sort",
    children: /*#__PURE__*/_jsx(ReactSVG, {
      src: toAbsoluteUrl("/media/svg/icons/Shopping/Sort1.svg")
    })
  });else if (order === "asc") return /*#__PURE__*/_jsx("span", {
    className: "svg-icon svg-icon-sm svg-icon-primary ml-1",
    children: /*#__PURE__*/_jsx(ReactSVG, {
      src: toAbsoluteUrl("/media/svg/icons/Navigation/Up-2.svg")
    })
  });else if (order === "desc") return /*#__PURE__*/_jsx("span", {
    className: "svg-icon svg-icon-sm svg-icon-primary ml-1",
    children: /*#__PURE__*/_jsx(ReactSVG, {
      src: toAbsoluteUrl("/media/svg/icons/Navigation/Down-2.svg")
    })
  });
  return null;
}; //Handle Sorting Class

var headerSortingClasses = function headerSortingClasses(column, sortOrder, isLastSorting, colIndex) {
  return sortOrder === "ASC" || sortOrder === "DESC" ? "sortable-active" : "";
}; //Alignment Formater

var FormatAlignment = function FormatAlignment(value, row) {
  var align = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "left";
  return /*#__PURE__*/_jsx("span", {
    className: "d-block text-".concat(align),
    children: value
  });
}; //image filter

var FormateImage = function FormateImage(value, row) {
  var size = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;
  return /*#__PURE__*/_jsx("span", {
    className: "images",
    children: /*#__PURE__*/_jsx("img", {
      src: value !== null && value !== void 0 ? value : "/images/image.png",
      alt: "",
      width: size !== null && size !== void 0 ? size : 50
    })
  });
}; //Status Column Filter

var StatusColumnFormatter = function StatusColumnFormatter(cell, row) {
  var getLabelCssClasses = function getLabelCssClasses() {
    return "statusLabel ".concat(actionStatus[cell]);
  };

  return /*#__PURE__*/_jsx("span", {
    className: getLabelCssClasses(),
    children: actionStatus[cell]
  });
};
var ActionsColumnFormatter = function ActionsColumnFormatter(cellContent, row, rowIndex, _ref) {
  var _ref$viewAction = _ref.viewAction,
      viewAction = _ref$viewAction === void 0 ? false : _ref$viewAction,
      _ref$detailAction = _ref.detailAction,
      detailAction = _ref$detailAction === void 0 ? false : _ref$detailAction,
      _ref$editAction = _ref.editAction,
      editAction = _ref$editAction === void 0 ? false : _ref$editAction,
      _ref$deleteAction = _ref.deleteAction,
      deleteAction = _ref$deleteAction === void 0 ? false : _ref$deleteAction,
      _ref$restoreAction = _ref.restoreAction,
      restoreAction = _ref$restoreAction === void 0 ? false : _ref$restoreAction,
      _ref$customComponent = _ref.customComponent,
      customComponent = _ref$customComponent === void 0 ? false : _ref$customComponent,
      _ref$customDropdown = _ref.customDropdown,
      customDropdown = _ref$customDropdown === void 0 ? false : _ref$customDropdown,
      _ref$viewMediaAction = _ref.viewMediaAction,
      viewMediaAction = _ref$viewMediaAction === void 0 ? false : _ref$viewMediaAction;
  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsx("div", {
      className: "table_cell_action",
      children: /*#__PURE__*/_jsxs("div", {
        className: "admin_action_button_wrapper",
        style: {
          justifyContent: "flex-end"
        },
        children: [viewAction && /*#__PURE__*/_jsx("a", {
          title: "View Details",
          className: "admin_action_button hover_blue",
          onClick: function onClick(e) {
            e.preventDefault();
            viewAction(row);
          },
          children: /*#__PURE__*/_jsx(MdLaunch, {})
        }), detailAction && /*#__PURE__*/_jsx("a", {
          title: "View Details",
          className: "admin_action_button hover_blue",
          onClick: function onClick(e) {
            e.preventDefault();
            detailAction(row);
          },
          children: /*#__PURE__*/_jsx(IoEyeOutline, {
            fontSize: "16px"
          })
        }), viewMediaAction && /*#__PURE__*/_jsx("a", {
          title: "View",
          target: "_blank",
          href: row.src,
          rel: "noopener",
          className: "admin_action_button hover_blue",
          children: /*#__PURE__*/_jsx(IoEyeOutline, {
            fontSize: "16px"
          })
        }), customComponent ? customComponent(row) : "", (editAction || deleteAction || customDropdown) && /*#__PURE__*/_jsxs("div", {
          className: "action_more_dropdown_wrapper",
          style: {
            marginLeft: "unset"
          },
          children: [/*#__PURE__*/_jsx(MdMoreVert, {
            className: "table_cell_action_more",
            style: {
              marginTop: "4px"
            }
          }), /*#__PURE__*/_jsx("div", {
            className: "action_more_dropdown",
            children: /*#__PURE__*/_jsxs("ul", {
              children: [editAction && row.status != "Deleted" && /*#__PURE__*/_jsxs("li", {
                onClick: function onClick(e) {
                  e.preventDefault();
                  editAction(row);
                },
                children: [/*#__PURE__*/_jsx(MdModeEdit, {
                  className: "action_more_dropdown_icon"
                }), /*#__PURE__*/_jsx("span", {
                  children: "Edit"
                })]
              }), restoreAction && row.status == "Deleted" && /*#__PURE__*/_jsxs("li", {
                onClick: function onClick() {
                  restoreAction(row);
                },
                children: [/*#__PURE__*/_jsx(MdRestore, {
                  className: "action_more_dropdown_icon"
                }), /*#__PURE__*/_jsx("span", {
                  children: "Restore"
                })]
              }), deleteAction && row.status != "Deleted" && /*#__PURE__*/_jsxs("li", {
                onClick: function onClick() {
                  deleteAction(row);
                },
                children: [/*#__PURE__*/_jsx(MdDelete, {
                  className: "action_more_dropdown_icon"
                }), /*#__PURE__*/_jsx("span", {
                  children: "Trash"
                })]
              }), deleteAction && row.status == "Deleted" && /*#__PURE__*/_jsxs("li", {
                onClick: function onClick() {
                  deleteAction(row);
                },
                children: [/*#__PURE__*/_jsx(MdDeleteForever, {
                  className: "action_more_dropdown_icon"
                }), /*#__PURE__*/_jsx("span", {
                  children: "Delete"
                })]
              }), customDropdown ? customDropdown(row) : ""]
            })
          })]
        })]
      })
    }, row.id)
  });
}; //update switcher actions

var switcherActions = function switcherActions(cellcontent, row, rowIndex, _ref2) {
  var handleAction = _ref2.handleAction;
  return /*#__PURE__*/_jsx(Switch, {
    checked: cellcontent && cellcontent == 1 ? true : false,
    onChange: function onChange(e) {
      return handleAction(e, row);
    },
    inputProps: {
      "aria-label": "controlled"
    },
    size: "small"
  });
}; //update status actions

var statusActions = function statusActions(cellcontent, row, rowIndex, _ref3) {
  var handleAction = _ref3.handleAction;
  return /*#__PURE__*/_jsx(Switch, {
    checked: cellcontent && cellcontent == 1 ? true : false,
    onChange: function onChange(e) {
      return handleAction(e, row);
    },
    inputProps: {
      "aria-label": "controlled"
    }
  });
}; //row selection

var RowSelection = function RowSelection(data, setstate, id) {
  return {
    mode: "checkbox",
    clickToSelect: false,
    classes: "selection-row",
    selected: data,
    onSelect: function onSelect(row, isSelect, rowIndex, e) {
      if (isSelect) {
        setstate(function (item) {
          return [].concat(_toConsumableArray(item), [row[id]]);
        });
      } else {
        setstate(data.filter(function (item) {
          return item != row[id];
        }));
      }
    },
    onSelectAll: function onSelectAll(isSelect, rows, e) {
      if (isSelect) {
        setstate(rows.map(function (item) {
          return item[id];
        }));
      } else {
        setstate([]);
      }
    }
  };
}; //Pagination Helpers

var customPagination = function customPagination(paginationInfo, paginationHandler) {
  //pagination factgory
  var customTotal = function customTotal(from, to, size) {
    return /*#__PURE__*/_jsxs("span", {
      className: "react-bootstrap-table-pagination-total",
      children: ["Showing ", from, " to ", to, " of ", size, " Results"]
    });
  };

  if (paginationInfo !== null && paginationInfo !== void 0 && paginationInfo.totalRows) {
    return paginationFactory({
      page: paginationInfo.currentPage,
      paginationSize: 4,
      pageStartIndex: 1,
      // alwaysShowAllBtns: true, // Always show next and previous button
      // withFirstAndLast: false, // Hide the going to First and Last page button
      // hideSizePerPage: true, // Hide the sizePerPage dropdown always
      // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
      firstPageText: "First",
      prePageText: "Back",
      nextPageText: "Next",
      lastPageText: "Last",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      showTotal: true,
      totalSize: paginationInfo === null || paginationInfo === void 0 ? void 0 : paginationInfo.totalRows,
      paginationTotalRenderer: customTotal,
      disablePageTitle: true,
      sizePerPageList: [{
        text: "5",
        value: 5
      }, {
        text: "10",
        value: 10
      }, {
        text: "20",
        value: 20
      }, {
        text: "All",
        value: paginationInfo === null || paginationInfo === void 0 ? void 0 : paginationInfo.totalRows
      }],
      onSizePerPageChange: function onSizePerPageChange(sizePerPage, page) {
        if (paginationHandler) {
          console.log(sizePerPage, page);
          paginationHandler({
            pageSize: sizePerPage,
            pageNumber: page
          });
        }
      },
      onPageChange: function onPageChange(page, sizePerPage) {
        console.log(sizePerPage, page);

        if (paginationHandler) {
          paginationHandler({
            pageSize: sizePerPage,
            pageNumber: page
          });
        }
      }
    });
  }
}; //Top Pagination Handler

var TopPaginationHandler = function TopPaginationHandler(_ref4) {
  var paginationInfo = _ref4.paginationInfo,
      paginationHandler = _ref4.paginationHandler,
      customClasses = _ref4.customClasses,
      props = (0,_Users_nadeem_workspaces_m4yours_myunisearch_workspaces_frontend_live_source_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_ref4, _excluded);

  var handlePager = function handlePager(e, page) {
    paginationHandler("pagination", {
      sizePerPage: paginationInfo.limit,
      page: parseInt(page) + 1
    });
  };

  if ((paginationInfo === null || paginationInfo === void 0 ? void 0 : paginationInfo.totalRows) > 0) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
      children: ["Showing:", paginationInfo && paginationInfo.totalRows && paginationInfo.currentPage && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        backIconButtonProps: {
          disableRipple: true
        },
        nextIconButtonProps: {
          disableRipple: true
        },
        rowsPerPageOptions: [],
        classes: {
          root: "".concat(customClasses !== null && customClasses !== void 0 && customClasses.root ? customClasses.root : ""),
          toolbar: "".concat(customClasses !== null && customClasses !== void 0 && customClasses.toolbar ? customClasses.toolbar : ""),
          actions: "".concat(customClasses !== null && customClasses !== void 0 && customClasses.actions ? customClasses.actions : "")
        },
        count: paginationInfo.totalRows,
        page: parseInt(paginationInfo.currentPage) - 1,
        rowsPerPage: paginationInfo.limit,
        onPageChange: handlePager,
        component: "div"
      })]
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.Fragment, {});
};
var UniTableComponent = function UniTableComponent(_ref5) {
  var _pagination$currentPa, _pagination$limit, _pagination$totalRows;

  var _ref5$data = _ref5.data,
      data = _ref5$data === void 0 ? [] : _ref5$data,
      _ref5$columns = _ref5.columns,
      columns = _ref5$columns === void 0 ? [] : _ref5$columns,
      _ref5$keyField = _ref5.keyField,
      keyField = _ref5$keyField === void 0 ? "id" : _ref5$keyField,
      _ref5$pagination = _ref5.pagination,
      pagination = _ref5$pagination === void 0 ? false : _ref5$pagination,
      onTableChange = _ref5.onTableChange,
      selectRow = _ref5.selectRow;
  //pagination info
  var page = (_pagination$currentPa = pagination === null || pagination === void 0 ? void 0 : pagination.currentPage) !== null && _pagination$currentPa !== void 0 ? _pagination$currentPa : 1;
  var sizePerPage = (_pagination$limit = pagination === null || pagination === void 0 ? void 0 : pagination.limit) !== null && _pagination$limit !== void 0 ? _pagination$limit : 10;
  var totalSize = (_pagination$totalRows = pagination === null || pagination === void 0 ? void 0 : pagination.totalRows) !== null && _pagination$totalRows !== void 0 ? _pagination$totalRows : 0;

  if (pagination) {
    return /*#__PURE__*/_jsx(BootstrapTable, {
      remote: true,
      keyField: keyField,
      data: data,
      columns: columns,
      pagination: paginationFactory({
        page: page,
        sizePerPage: sizePerPage,
        totalSize: totalSize
      }),
      onTableChange: onTableChange,
      selectRow: selectRow
    });
  }

  return /*#__PURE__*/_jsx(BootstrapTable, {
    remote: true,
    keyField: keyField,
    data: data,
    columns: columns,
    onTableChange: onTableChange,
    selectRow: selectRow
  });
}; //name column formater

var NameColumnFormatter = function NameColumnFormatter(row) {
  var renderData = function renderData() {
    var _row$name;

    return /*#__PURE__*/_jsxs("div", {
      className: "table-profile",
      children: [/*#__PURE__*/_jsx("div", {
        className: "profile-image",
        children: /*#__PURE__*/_jsx("img", {
          src: (row === null || row === void 0 ? void 0 : row.profileImage) || getAssets("assets/student-avatar-small.png"),
          alt: (_row$name = row === null || row === void 0 ? void 0 : row.name) !== null && _row$name !== void 0 ? _row$name : ""
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "profile-content",
        children: [(row === null || row === void 0 ? void 0 : row.name) && /*#__PURE__*/_jsxs("span", {
          className: "profile-name",
          children: [" ", row.name]
        }), (row === null || row === void 0 ? void 0 : row.role) && /*#__PURE__*/_jsxs("span", {
          className: "profile-designation",
          children: [" ", row.role]
        }), (row === null || row === void 0 ? void 0 : row.designation) && /*#__PURE__*/_jsxs("span", {
          className: "profile-designation",
          children: [" ", row.designation]
        }), (row === null || row === void 0 ? void 0 : row.subDesignation) && /*#__PURE__*/_jsx("span", {
          className: "profile-subDesignation",
          children: row.subDesignation
        }), (row === null || row === void 0 ? void 0 : row.email) && /*#__PURE__*/_jsxs("span", {
          className: "profile-email",
          children: [" ", row.email]
        })]
      })]
    });
  };

  if (row !== null && row !== void 0 && row.link) {
    return /*#__PURE__*/_jsx(Link, {
      legacyBehavior: true,
      href: row === null || row === void 0 ? void 0 : row.link,
      children: /*#__PURE__*/_jsx("a", {
        children: renderData()
      })
    });
  } else {
    return renderData();
  }
}; //name column formater

var FileColumnFormater = function FileColumnFormater() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  if (!data) return /*#__PURE__*/_jsx("div", {
    className: "tableImage",
    children: /*#__PURE__*/_jsx("img", {
      src: "/assets/images/vector-image.png",
      alt: ""
    })
  });
  var extension = data.split(".").pop();

  if (extension == "pdf") {
    return /*#__PURE__*/_jsx("div", {
      className: "tableFileIcon",
      children: /*#__PURE__*/_jsx(ReactSVG, {
        src: getAssets("assets/icons/pdf_icon.svg")
      })
    });
  }

  if (extension == "xlsx" || extension == "xls") {
    return /*#__PURE__*/_jsx("div", {
      className: "tableFileIcon",
      children: /*#__PURE__*/_jsx(ReactSVG, {
        src: getAssets("assets/icons/xls_icon.svg")
      })
    });
  }

  if (extension == "docx" || extension == "doc") {
    return /*#__PURE__*/_jsx("div", {
      className: "tableFileIcon",
      children: /*#__PURE__*/_jsx(ReactSVG, {
        src: getAssets("assets/icons/doc_icon.svg")
      })
    });
  }

  if (extension == "mp4") {
    return /*#__PURE__*/_jsx("div", {
      className: "tableVideo",
      children: /*#__PURE__*/_jsxs("video", {
        width: "100%",
        height: "180",
        controls: "controls",
        preload: "none",
        children: [/*#__PURE__*/_jsx("source", {
          src: imageUrl,
          type: "video/mp4",
          autostart: "false"
        }), "Your browser does not support the video tag."]
      })
    });
  }

  if (extension == "jpg" || extension == "jpeg" || extension == "png" || extension == "webp" || extension == "svg") {
    return /*#__PURE__*/_jsx("div", {
      className: "tableImage",
      children: /*#__PURE__*/_jsx("img", {
        src: data,
        alt: ""
      })
    });
  }

  return /*#__PURE__*/_jsx("div", {
    className: "tableImage",
    children: /*#__PURE__*/_jsx("img", {
      src: data,
      alt: ""
    })
  });
};

/***/ }),

/***/ 31118:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pickearWrapper":"datepicker_pickearWrapper__XkeyT","pickerIcon":"datepicker_pickerIcon__GHvMw"};

/***/ }),

/***/ 10396:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"course_screen_wrapper__bOC5K","headingWrapper":"course_screen_headingWrapper__KaJZF","headingLeft":"course_screen_headingLeft__8KCT7","image_wrapper":"course_screen_image_wrapper__kNKg1","heading":"course_screen_heading__jtdmb","table_heading":"course_screen_table_heading__FbM14"};

/***/ }),

/***/ 49037:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"shwing_num":"show_paginate_text_shwing_num__VYp5P"};

/***/ }),

/***/ 82641:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pagination_wrapper":"pagination_pagination_wrapper__EZ8Eh","shwing_num":"pagination_shwing_num___10Qi"};

/***/ })

}]);